/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Chkk API v1.0
 * Chkk API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */
import useSwr from 'swr';
import type { Arguments, Key, SWRConfiguration } from 'swr';
import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';
import type {
  AccountStats,
  AcknowledgeLARRequest,
  AddTeamMemberRequest,
  AddonInstance,
  Agent,
  AgentRecipeMetadata,
  AgentSlug,
  AmplitudeAnalyticsReport,
  AvailabilityRisksSummary,
  ChatGet200,
  ChatPost200,
  ChatPost201,
  ChatPostBody,
  CloudConnection,
  CloudConnectionAction,
  Cluster,
  ClusterDetectedLar,
  ClusterNodesResponse,
  ClusterScan,
  CompoundListClustersResponse,
  CrdsPresignResponse,
  CreateAccountTeamRequest,
  CreateCloudConnectionActionRequest,
  CreateCloudConnectionRequest,
  CreateClusterRequest,
  CreateClusterScanRequest,
  CreateIngestionTokenRequest,
  CreateIntegrationRequest,
  CreateOrganizationRequest,
  CreatePackageUpgradeContextRequest,
  CreatePackageUpgradeContextResponse,
  CreateSSOConfigurationRequest,
  CreateScanRequest,
  CreateScanResponse,
  CreateSubscriptionRequest,
  CreateSubscriptionResponse,
  CreateTicketRequest,
  CreateUpgradeAssessmentRequest,
  CreateUpgradeAssessmentStageStepActionRequest,
  CreateUpgradeAssessmentStageStepCommentRequest,
  CreateUpgradeAssessmentStageStepRequest,
  CreateUpgradePlanRequest,
  CreateUpgradePlanStageActionRequest,
  CreateUpgradePlanStageStepActionRequest,
  CreateUpgradePlanStageStepCommentRequest,
  CreateUpgradePlanStageStepRequest,
  CreateUpgradeTemplateRequest,
  CreateUpgradeTemplateStageActionRequest,
  CreateUpgradeTemplateStageStepActionRequest,
  CreateUpgradeTemplateStageStepCommentRequest,
  CreateUpgradeTemplateStageStepRequest,
  DeleteUpgradeAssessmentStageStepCommentRequest,
  DeleteUpgradeTemplateStageStepCommentRequest,
  ExportUpgradeAssessmentParams,
  ExportUpgradePlanParams,
  ExportUpgradeTemplateParams,
  FinalizePackageUpgradeContextRequest,
  GcpMarketplaceSubscriptionRequest,
  GcpMarketplaceSubscriptionResponse,
  GetAccountStatsParams,
  GetAvailabilityRiskAffectedResourceParams,
  GetAvailabilityRisksSummaryParams,
  GetIngestionTokenResponse,
  GetPackageDiffParams,
  GetPrometheusStatusParams,
  GetSHARCProjectImagesParams,
  GetSHARCProjectImagesResponse,
  GetTicketDetailsResponse,
  GetUpgradeTemplateProjectPackageSnapshotParams,
  GetUsersResponse,
  IgnoreLARRequest,
  IngestionToken,
  Integration,
  LARStatus,
  LarsOverviewResponse,
  ListAccessTokensResponse,
  ListAccountAddonsParams,
  ListAccountAddonsResponse,
  ListAccountTeamsParams,
  ListAccountTeamsResponse,
  ListAddonInstanceResourcesResponse,
  ListAddonInstancesParams,
  ListAddonInstancesResponse,
  ListAffectedResourcesResponse,
  ListAllTreatmentsResponse,
  ListAvailabilityRisksParams,
  ListAvailabilityRisksResponse,
  ListCloudConnectionsParams,
  ListCloudConnectionsResponse,
  ListClusterScanLARResourcesParams,
  ListClusterScanLARResourcesResponse,
  ListClusterScanLARsParams,
  ListClusterScanLARsResponse,
  ListClusterScanSignaturesParams,
  ListClusterScanSignaturesResponse,
  ListClusterScansParams,
  ListClusterScansResponse,
  ListClusterScansResponseV2,
  ListClustersParams,
  ListDirectoryAddonsParams,
  ListDirectoryAddonsResponse,
  ListIngestionTokensResponse,
  ListIntegrationsResponse,
  ListLARsStatusResponse,
  ListPackageUpgradeContextsParams,
  ListPackageUpgradeContextsResponse,
  ListProjectChecksParams,
  ListProjectChecksResponse,
  ListProjectReleasesParams,
  ListProjectReleasesResponse,
  ListRiskAffectedResourcesParams,
  ListRiskResourcesResponse,
  ListRisksParams,
  ListRisksResponse,
  ListSHARCFlowRunsResponse,
  ListSHARCFlowrunsParams,
  ListSHARCImagesResponse,
  ListSubagentsParams,
  ListSubagentsResponse,
  ListSubscriptionsParams,
  ListSubscriptionsResponse,
  ListTeamInvitationsParams,
  ListTeamInvitationsResponse,
  ListUpgradeAssessmentHistoryParams,
  ListUpgradeAssessmentHistoryResponse,
  ListUpgradeAssessmentPackageInstallChangeReasonsResponse,
  ListUpgradeAssessmentPackageInstallChangesParams,
  ListUpgradeAssessmentPackageInstallChangesResponse,
  ListUpgradeAssessmentStageStepCommentsParams,
  ListUpgradeAssessmentStageStepCommentsResponse,
  ListUpgradeAssessmentStageStepsParams,
  ListUpgradeAssessmentStageStepsResponse,
  ListUpgradeAssessmentStagesParams,
  ListUpgradeAssessmentStagesResponse,
  ListUpgradeAssessmentUnclassifiedResourcesParams,
  ListUpgradeAssessmentUnclassifiedResourcesResponse,
  ListUpgradeAssessmentsParams,
  ListUpgradeAssessmentsResponse,
  ListUpgradePlanHistoryParams,
  ListUpgradePlanHistoryResponse,
  ListUpgradePlanPackageInstallChangeReasonsResponse,
  ListUpgradePlanPackageInstallChangesParams,
  ListUpgradePlanPackageInstallChangesResponse,
  ListUpgradePlanStageActionsParams,
  ListUpgradePlanStageActionsResponse,
  ListUpgradePlanStageStepActionsParams,
  ListUpgradePlanStageStepActionsResponse,
  ListUpgradePlanStageStepCommentsParams,
  ListUpgradePlanStageStepCommentsResponse,
  ListUpgradePlanStageStepsParams,
  ListUpgradePlanStageStepsResponse,
  ListUpgradePlanStagesParams,
  ListUpgradePlanStagesResponse,
  ListUpgradePlansParams,
  ListUpgradePlansResponse,
  ListUpgradeTemplateHistoryParams,
  ListUpgradeTemplateHistoryResponse,
  ListUpgradeTemplateStageActionsParams,
  ListUpgradeTemplateStageActionsResponse,
  ListUpgradeTemplateStageStepActionsParams,
  ListUpgradeTemplateStageStepActionsResponse,
  ListUpgradeTemplateStageStepCommentsParams,
  ListUpgradeTemplateStageStepCommentsResponse,
  ListUpgradeTemplateStageStepsParams,
  ListUpgradeTemplateStageStepsResponse,
  ListUpgradeTemplateStagesParams,
  ListUpgradeTemplateStagesResponse,
  ListUpgradeTemplatesParams,
  ListUpgradeTemplatesResponse,
  LoginParams,
  LoginResponse,
  NotableChanges,
  Organization,
  PackageInstallChange,
  PackageUpgradeContext,
  ProxyAmplitudeEvent200,
  QuickStartResponse,
  RescanClusterRequest,
  ResolvedSubscription,
  Risk,
  SHARCFlowRun,
  SSOConfiguration,
  Skill,
  SkillRecipeMetadata,
  SkillSlug,
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
  Team,
  TeamInvitation,
  UpdateAccountTeamRequest,
  UpdateCloudConnectionRequest,
  UpdateClusterRequest,
  UpdateIngestionTokenRequest,
  UpdateIntegrationRequest,
  UpdateLARStatusRequest,
  UpdateOrganizationRequest,
  UpdateSSOConfigurationRequest,
  UpdateSubscriptionRequest,
  UpdateUpgradeAssessmentRequest,
  UpdateUpgradeAssessmentStageStepRequest,
  UpdateUpgradePlanRequest,
  UpdateUpgradePlanStageStepRequest,
  UpdateUpgradeTemplateRequest,
  UpdateUpgradeTemplateStageStepRequest,
  UpgradeAssessment,
  UpgradePlan,
  UpgradeStage,
  UpgradeStageAction,
  UpgradeStageStep,
  UpgradeStageStepAction,
  UpgradeTemplate,
  UploadPackageUpgradeContextTelemetryRequest,
  UploadPackageUpgradeContextTelemetryResponse,
} from './models';
import { customInstance } from './axios-instance';
import type { ErrorType, BodyType } from './axios-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Retrieve all the Cloud Connections associated with a Chkk account
 */
export const listCloudConnections = (
  params?: ListCloudConnectionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListCloudConnectionsResponse>(
    { url: `/connection/clouds`, method: 'GET', params },
    options,
  );
};

export const getListCloudConnectionsKey = (
  params?: ListCloudConnectionsParams,
) => [`/connection/clouds`, ...(params ? [params] : [])] as const;

export type ListCloudConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCloudConnections>>
>;
export type ListCloudConnectionsQueryError = ErrorType<unknown>;

export const useListCloudConnections = <TError = ErrorType<unknown>>(
  params?: ListCloudConnectionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listCloudConnections>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListCloudConnectionsKey(params) : null));
  const swrFn = () => listCloudConnections(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Establish a connection between Chkk and your Cloud
 * @summary Create a cloud connection
 */
export const createCloudConnection = (
  createCloudConnectionRequest: BodyType<CreateCloudConnectionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CloudConnection>(
    {
      url: `/connection/clouds`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCloudConnectionRequest,
    },
    options,
  );
};

export const getCreateCloudConnectionMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateCloudConnectionRequest },
  ): Promise<CloudConnection> => {
    return createCloudConnection(arg, options);
  };
};
export const getCreateCloudConnectionMutationKey = () =>
  `/connection/clouds` as const;

export type CreateCloudConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCloudConnection>>
>;
export type CreateCloudConnectionMutationError = ErrorType<unknown>;

/**
 * @summary Create a cloud connection
 */
export const useCreateCloudConnection = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createCloudConnection>>,
    TError,
    string,
    CreateCloudConnectionRequest,
    Awaited<ReturnType<typeof createCloudConnection>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateCloudConnectionMutationKey();
  const swrFn = getCreateCloudConnectionMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes the specified Cloud Connection.
 * @summary Delete a Cloud Connection
 */
export const deleteCloudConnection = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/connection/clouds/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteCloudConnectionMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteCloudConnection(id, options);
  };
};
export const getDeleteCloudConnectionMutationKey = (id: string) =>
  `/connection/clouds/${id}` as const;

export type DeleteCloudConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCloudConnection>>
>;
export type DeleteCloudConnectionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a Cloud Connection
 */
export const useDeleteCloudConnection = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteCloudConnection>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteCloudConnection>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteCloudConnectionMutationKey(id);
  const swrFn = getDeleteCloudConnectionMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Cloud Connection.
 * @summary Get information about a Cloud Connection
 */
export const getCloudConnection = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CloudConnection>(
    { url: `/connection/clouds/${id}`, method: 'GET' },
    options,
  );
};

export const getGetCloudConnectionKey = (id: string) =>
  [`/connection/clouds/${id}`] as const;

export type GetCloudConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCloudConnection>>
>;
export type GetCloudConnectionQueryError = ErrorType<void>;

/**
 * @summary Get information about a Cloud Connection
 */
export const useGetCloudConnection = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getCloudConnection>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetCloudConnectionKey(id) : null));
  const swrFn = () => getCloudConnection(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Updates the specified Cloud Connection.
 * @summary Update a Cloud Connection
 */
export const updateCloudConnection = (
  id: string,
  updateCloudConnectionRequest: BodyType<UpdateCloudConnectionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CloudConnection>(
    {
      url: `/connection/clouds/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCloudConnectionRequest,
    },
    options,
  );
};

export const getUpdateCloudConnectionMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateCloudConnectionRequest },
  ): Promise<CloudConnection> => {
    return updateCloudConnection(id, arg, options);
  };
};
export const getUpdateCloudConnectionMutationKey = (id: string) =>
  `/connection/clouds/${id}` as const;

export type UpdateCloudConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCloudConnection>>
>;
export type UpdateCloudConnectionMutationError = ErrorType<unknown>;

/**
 * @summary Update a Cloud Connection
 */
export const useUpdateCloudConnection = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateCloudConnection>>,
      TError,
      string,
      UpdateCloudConnectionRequest,
      Awaited<ReturnType<typeof updateCloudConnection>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateCloudConnectionMutationKey(id);
  const swrFn = getUpdateCloudConnectionMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the cloud connection object. Action could be to verify the connection
 * @summary Trigger an action on the object
 */
export const createCloudConnectionAction = (
  id: string,
  createCloudConnectionActionRequest: BodyType<CreateCloudConnectionActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CloudConnectionAction>(
    {
      url: `/connection/clouds/${id}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCloudConnectionActionRequest,
    },
    options,
  );
};

export const getCreateCloudConnectionActionMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateCloudConnectionActionRequest },
  ): Promise<CloudConnectionAction> => {
    return createCloudConnectionAction(id, arg, options);
  };
};
export const getCreateCloudConnectionActionMutationKey = (id: string) =>
  `/connection/clouds/${id}/actions` as const;

export type CreateCloudConnectionActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCloudConnectionAction>>
>;
export type CreateCloudConnectionActionMutationError = ErrorType<unknown>;

/**
 * @summary Trigger an action on the object
 */
export const useCreateCloudConnectionAction = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createCloudConnectionAction>>,
      TError,
      string,
      CreateCloudConnectionActionRequest,
      Awaited<ReturnType<typeof createCloudConnectionAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateCloudConnectionActionMutationKey(id);
  const swrFn = getCreateCloudConnectionActionMutationFetcher(
    id,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Accept an invitation into a Chkk team. This does not require further authentication, as it only executes prior-created invitations.
 */
export const acceptInvitation = (
  inviteKey: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/accept/${inviteKey}`, method: 'POST' },
    options,
  );
};

export const getAcceptInvitationMutationFetcher = (
  inviteKey: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return acceptInvitation(inviteKey, options);
  };
};
export const getAcceptInvitationMutationKey = (inviteKey: string) =>
  `/accept/${inviteKey}` as const;

export type AcceptInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvitation>>
>;
export type AcceptInvitationMutationError = ErrorType<unknown>;

export const useAcceptInvitation = <TError = ErrorType<unknown>>(
  inviteKey: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof acceptInvitation>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof acceptInvitation>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getAcceptInvitationMutationKey(inviteKey);
  const swrFn = getAcceptInvitationMutationFetcher(inviteKey, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get Invitation By Key
 */
export const getInvitationByKey = (
  inviteKey: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TeamInvitation>(
    { url: `/invitations/${inviteKey}`, method: 'GET' },
    options,
  );
};

export const getGetInvitationByKeyKey = (inviteKey: string) =>
  [`/invitations/${inviteKey}`] as const;

export type GetInvitationByKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvitationByKey>>
>;
export type GetInvitationByKeyQueryError = ErrorType<unknown>;

export const useGetInvitationByKey = <TError = ErrorType<unknown>>(
  inviteKey: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getInvitationByKey>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!inviteKey;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetInvitationByKeyKey(inviteKey) : null));
  const swrFn = () => getInvitationByKey(inviteKey, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getAccountStats = (
  accountSlug: string,
  params?: GetAccountStatsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AccountStats>(
    { url: `/accounts/${accountSlug}/stats`, method: 'GET', params },
    options,
  );
};

export const getGetAccountStatsKey = (
  accountSlug: string,
  params?: GetAccountStatsParams,
) => [`/accounts/${accountSlug}/stats`, ...(params ? [params] : [])] as const;

export type GetAccountStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountStats>>
>;
export type GetAccountStatsQueryError = ErrorType<unknown>;

export const useGetAccountStats = <TError = ErrorType<unknown>>(
  accountSlug: string,
  params?: GetAccountStatsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAccountStats>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAccountStatsKey(accountSlug, params) : null));
  const swrFn = () => getAccountStats(accountSlug, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List all teams in the given Chkk account
 */
export const listAccountTeams = (
  accountSlug: string,
  params?: ListAccountTeamsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAccountTeamsResponse>(
    { url: `/accounts/${accountSlug}/teams`, method: 'GET', params },
    options,
  );
};

export const getListAccountTeamsKey = (
  accountSlug: string,
  params?: ListAccountTeamsParams,
) => [`/accounts/${accountSlug}/teams`, ...(params ? [params] : [])] as const;

export type ListAccountTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountTeams>>
>;
export type ListAccountTeamsQueryError = ErrorType<unknown>;

export const useListAccountTeams = <TError = ErrorType<unknown>>(
  accountSlug: string,
  params?: ListAccountTeamsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAccountTeams>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAccountTeamsKey(accountSlug, params) : null));
  const swrFn = () => listAccountTeams(accountSlug, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new team in the given Chkk account
 */
export const createAccountTeam = (
  accountSlug: string,
  createAccountTeamRequest: BodyType<CreateAccountTeamRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Team>(
    {
      url: `/accounts/${accountSlug}/teams`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAccountTeamRequest,
    },
    options,
  );
};

export const getCreateAccountTeamMutationFetcher = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateAccountTeamRequest },
  ): Promise<Team> => {
    return createAccountTeam(accountSlug, arg, options);
  };
};
export const getCreateAccountTeamMutationKey = (accountSlug: string) =>
  `/accounts/${accountSlug}/teams` as const;

export type CreateAccountTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountTeam>>
>;
export type CreateAccountTeamMutationError = ErrorType<unknown>;

export const useCreateAccountTeam = <TError = ErrorType<unknown>>(
  accountSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createAccountTeam>>,
      TError,
      string,
      CreateAccountTeamRequest,
      Awaited<ReturnType<typeof createAccountTeam>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateAccountTeamMutationKey(accountSlug);
  const swrFn = getCreateAccountTeamMutationFetcher(
    accountSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete an existing team in the given Chkk account
 */
export const deleteAccountTeam = (
  accountSlug: string,
  teamSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/accounts/${accountSlug}/teams/${teamSlug}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAccountTeamMutationFetcher = (
  accountSlug: string,
  teamSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteAccountTeam(accountSlug, teamSlug, options);
  };
};
export const getDeleteAccountTeamMutationKey = (
  accountSlug: string,
  teamSlug: string,
) => `/accounts/${accountSlug}/teams/${teamSlug}` as const;

export type DeleteAccountTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountTeam>>
>;
export type DeleteAccountTeamMutationError = ErrorType<unknown>;

export const useDeleteAccountTeam = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteAccountTeam>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteAccountTeam>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteAccountTeamMutationKey(accountSlug, teamSlug);
  const swrFn = getDeleteAccountTeamMutationFetcher(
    accountSlug,
    teamSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the details for a specific Chkk team in the Chkk account
 */
export const getAccountTeam = (
  accountSlug: string,
  teamSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Team>(
    { url: `/accounts/${accountSlug}/teams/${teamSlug}`, method: 'GET' },
    options,
  );
};

export const getGetAccountTeamKey = (accountSlug: string, teamSlug: string) =>
  [`/accounts/${accountSlug}/teams/${teamSlug}`] as const;

export type GetAccountTeamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountTeam>>
>;
export type GetAccountTeamQueryError = ErrorType<unknown>;

export const useGetAccountTeam = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAccountTeam>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountSlug && teamSlug);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAccountTeamKey(accountSlug, teamSlug) : null));
  const swrFn = () => getAccountTeam(accountSlug, teamSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an existing team in the given Chkk account
 */
export const updateAccountTeam = (
  accountSlug: string,
  teamSlug: string,
  updateAccountTeamRequest: BodyType<UpdateAccountTeamRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Team>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAccountTeamRequest,
    },
    options,
  );
};

export const getUpdateAccountTeamMutationFetcher = (
  accountSlug: string,
  teamSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateAccountTeamRequest },
  ): Promise<Team> => {
    return updateAccountTeam(accountSlug, teamSlug, arg, options);
  };
};
export const getUpdateAccountTeamMutationKey = (
  accountSlug: string,
  teamSlug: string,
) => `/accounts/${accountSlug}/teams/${teamSlug}` as const;

export type UpdateAccountTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountTeam>>
>;
export type UpdateAccountTeamMutationError = ErrorType<unknown>;

export const useUpdateAccountTeam = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateAccountTeam>>,
      TError,
      string,
      UpdateAccountTeamRequest,
      Awaited<ReturnType<typeof updateAccountTeam>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateAccountTeamMutationKey(accountSlug, teamSlug);
  const swrFn = getUpdateAccountTeamMutationFetcher(
    accountSlug,
    teamSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the pending invitations to the Chkk team.
 */
export const listTeamInvitations = (
  accountSlug: string,
  teamSlug: string,
  params?: ListTeamInvitationsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListTeamInvitationsResponse>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}/invitations`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListTeamInvitationsKey = (
  accountSlug: string,
  teamSlug: string,
  params?: ListTeamInvitationsParams,
) =>
  [
    `/accounts/${accountSlug}/teams/${teamSlug}/invitations`,
    ...(params ? [params] : []),
  ] as const;

export type ListTeamInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamInvitations>>
>;
export type ListTeamInvitationsQueryError = ErrorType<unknown>;

export const useListTeamInvitations = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  params?: ListTeamInvitationsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listTeamInvitations>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(accountSlug && teamSlug);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListTeamInvitationsKey(accountSlug, teamSlug, params)
        : null);
  const swrFn = () =>
    listTeamInvitations(accountSlug, teamSlug, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Cancel an invitation
 */
export const deleteTeamInvitation = (
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}/invitations/${invitationId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteTeamInvitationMutationFetcher = (
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteTeamInvitation(accountSlug, teamSlug, invitationId, options);
  };
};
export const getDeleteTeamInvitationMutationKey = (
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
) =>
  `/accounts/${accountSlug}/teams/${teamSlug}/invitations/${invitationId}` as const;

export type DeleteTeamInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeamInvitation>>
>;
export type DeleteTeamInvitationMutationError = ErrorType<unknown>;

export const useDeleteTeamInvitation = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteTeamInvitation>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteTeamInvitation>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteTeamInvitationMutationKey(accountSlug, teamSlug, invitationId);
  const swrFn = getDeleteTeamInvitationMutationFetcher(
    accountSlug,
    teamSlug,
    invitationId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve the details of the invitation
 */
export const getTeamInvitation = (
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TeamInvitation>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}/invitations/${invitationId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetTeamInvitationKey = (
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
) =>
  [
    `/accounts/${accountSlug}/teams/${teamSlug}/invitations/${invitationId}`,
  ] as const;

export type GetTeamInvitationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamInvitation>>
>;
export type GetTeamInvitationQueryError = ErrorType<unknown>;

export const useGetTeamInvitation = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  invitationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getTeamInvitation>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    !!(accountSlug && teamSlug && invitationId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetTeamInvitationKey(accountSlug, teamSlug, invitationId)
        : null);
  const swrFn = () =>
    getTeamInvitation(accountSlug, teamSlug, invitationId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Add a new member to an existing Chkk Team. This creates an invitation as well as an email notification to the person added to accept the invitation (beforehand they will not be a member)
 */
export const addTeamMember = (
  accountSlug: string,
  teamSlug: string,
  addTeamMemberRequest: BodyType<AddTeamMemberRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}/membership`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addTeamMemberRequest,
    },
    options,
  );
};

export const getAddTeamMemberMutationFetcher = (
  accountSlug: string,
  teamSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, { arg }: { arg: AddTeamMemberRequest }): Promise<void> => {
    return addTeamMember(accountSlug, teamSlug, arg, options);
  };
};
export const getAddTeamMemberMutationKey = (
  accountSlug: string,
  teamSlug: string,
) => `/accounts/${accountSlug}/teams/${teamSlug}/membership` as const;

export type AddTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTeamMember>>
>;
export type AddTeamMemberMutationError = ErrorType<unknown>;

export const useAddTeamMember = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof addTeamMember>>,
      TError,
      string,
      AddTeamMemberRequest,
      Awaited<ReturnType<typeof addTeamMember>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getAddTeamMemberMutationKey(accountSlug, teamSlug);
  const swrFn = getAddTeamMemberMutationFetcher(
    accountSlug,
    teamSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Remove a user from a Chkk team. The user won't be notified about this change.
 */
export const deleteTeamMember = (
  accountSlug: string,
  teamSlug: string,
  userId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/accounts/${accountSlug}/teams/${teamSlug}/membership/${userId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteTeamMemberMutationFetcher = (
  accountSlug: string,
  teamSlug: string,
  userId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteTeamMember(accountSlug, teamSlug, userId, options);
  };
};
export const getDeleteTeamMemberMutationKey = (
  accountSlug: string,
  teamSlug: string,
  userId: string,
) => `/accounts/${accountSlug}/teams/${teamSlug}/membership/${userId}` as const;

export type DeleteTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeamMember>>
>;
export type DeleteTeamMemberMutationError = ErrorType<unknown>;

export const useDeleteTeamMember = <TError = ErrorType<unknown>>(
  accountSlug: string,
  teamSlug: string,
  userId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteTeamMember>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteTeamMember>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteTeamMemberMutationKey(accountSlug, teamSlug, userId);
  const swrFn = getDeleteTeamMemberMutationFetcher(
    accountSlug,
    teamSlug,
    userId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete SSO Configuration for an Account
 * @summary Delete SSO Configuration for an Account
 */
export const deleteAccountSSOConfiguration = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/accounts/${accountSlug}/sso/configuration`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAccountSSOConfigurationMutationFetcher = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteAccountSSOConfiguration(accountSlug, options);
  };
};
export const getDeleteAccountSSOConfigurationMutationKey = (
  accountSlug: string,
) => `/accounts/${accountSlug}/sso/configuration` as const;

export type DeleteAccountSSOConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountSSOConfiguration>>
>;
export type DeleteAccountSSOConfigurationMutationError = ErrorType<unknown>;

/**
 * @summary Delete SSO Configuration for an Account
 */
export const useDeleteAccountSSOConfiguration = <TError = ErrorType<unknown>>(
  accountSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteAccountSSOConfiguration>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteAccountSSOConfiguration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteAccountSSOConfigurationMutationKey(accountSlug);
  const swrFn = getDeleteAccountSSOConfigurationMutationFetcher(
    accountSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns SSO Configuration for an Account
 * @summary Get SSO Configuration for the Account
 */
export const getAccountSSOConfiguration = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SSOConfiguration>(
    { url: `/accounts/${accountSlug}/sso/configuration`, method: 'GET' },
    options,
  );
};

export const getGetAccountSSOConfigurationKey = (accountSlug: string) =>
  [`/accounts/${accountSlug}/sso/configuration`] as const;

export type GetAccountSSOConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountSSOConfiguration>>
>;
export type GetAccountSSOConfigurationQueryError = ErrorType<void>;

/**
 * @summary Get SSO Configuration for the Account
 */
export const useGetAccountSSOConfiguration = <TError = ErrorType<void>>(
  accountSlug: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAccountSSOConfiguration>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!accountSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAccountSSOConfigurationKey(accountSlug) : null));
  const swrFn = () => getAccountSSOConfiguration(accountSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create SSO Configuration for an Account
 * @summary Create SSO Configuration for an Account
 */
export const createAccountSSOConfiguration = (
  accountSlug: string,
  createSSOConfigurationRequest: BodyType<CreateSSOConfigurationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SSOConfiguration>(
    {
      url: `/accounts/${accountSlug}/sso/configuration`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSSOConfigurationRequest,
    },
    options,
  );
};

export const getCreateAccountSSOConfigurationMutationFetcher = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateSSOConfigurationRequest },
  ): Promise<SSOConfiguration> => {
    return createAccountSSOConfiguration(accountSlug, arg, options);
  };
};
export const getCreateAccountSSOConfigurationMutationKey = (
  accountSlug: string,
) => `/accounts/${accountSlug}/sso/configuration` as const;

export type CreateAccountSSOConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountSSOConfiguration>>
>;
export type CreateAccountSSOConfigurationMutationError = ErrorType<unknown>;

/**
 * @summary Create SSO Configuration for an Account
 */
export const useCreateAccountSSOConfiguration = <TError = ErrorType<unknown>>(
  accountSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createAccountSSOConfiguration>>,
      TError,
      string,
      CreateSSOConfigurationRequest,
      Awaited<ReturnType<typeof createAccountSSOConfiguration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateAccountSSOConfigurationMutationKey(accountSlug);
  const swrFn = getCreateAccountSSOConfigurationMutationFetcher(
    accountSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update SSO Configuration for an Account
 * @summary Update SSO Configuration for an Account
 */
export const updateAccountSSOConfiguration = (
  accountSlug: string,
  updateSSOConfigurationRequest: BodyType<UpdateSSOConfigurationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SSOConfiguration>(
    {
      url: `/accounts/${accountSlug}/sso/configuration`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSSOConfigurationRequest,
    },
    options,
  );
};

export const getUpdateAccountSSOConfigurationMutationFetcher = (
  accountSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateSSOConfigurationRequest },
  ): Promise<SSOConfiguration> => {
    return updateAccountSSOConfiguration(accountSlug, arg, options);
  };
};
export const getUpdateAccountSSOConfigurationMutationKey = (
  accountSlug: string,
) => `/accounts/${accountSlug}/sso/configuration` as const;

export type UpdateAccountSSOConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountSSOConfiguration>>
>;
export type UpdateAccountSSOConfigurationMutationError = ErrorType<unknown>;

/**
 * @summary Update SSO Configuration for an Account
 */
export const useUpdateAccountSSOConfiguration = <TError = ErrorType<unknown>>(
  accountSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateAccountSSOConfiguration>>,
      TError,
      string,
      UpdateSSOConfigurationRequest,
      Awaited<ReturnType<typeof updateAccountSSOConfiguration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateAccountSSOConfigurationMutationKey(accountSlug);
  const swrFn = getUpdateAccountSSOConfigurationMutationFetcher(
    accountSlug,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List all addons in the Chkk account
 */
export const listAccountAddons = (
  params?: ListAccountAddonsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAccountAddonsResponse>(
    { url: `/addons`, method: 'GET', params },
    options,
  );
};

export const getListAccountAddonsKey = (params?: ListAccountAddonsParams) =>
  [`/addons`, ...(params ? [params] : [])] as const;

export type ListAccountAddonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountAddons>>
>;
export type ListAccountAddonsQueryError = ErrorType<unknown>;

export const useListAccountAddons = <TError = ErrorType<unknown>>(
  params?: ListAccountAddonsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAccountAddons>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAccountAddonsKey(params) : null));
  const swrFn = () => listAccountAddons(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Endpoint for the Amplitude tunnel used by the web apps to report analytics.
 */
export const proxyAmplitudeEvent = (
  amplitudeAnalyticsReport: BodyType<AmplitudeAnalyticsReport>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ProxyAmplitudeEvent200>(
    {
      url: `/chkk-analytics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: amplitudeAnalyticsReport,
    },
    options,
  );
};

export const getProxyAmplitudeEventMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: AmplitudeAnalyticsReport },
  ): Promise<ProxyAmplitudeEvent200> => {
    return proxyAmplitudeEvent(arg, options);
  };
};
export const getProxyAmplitudeEventMutationKey = () =>
  `/chkk-analytics` as const;

export type ProxyAmplitudeEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof proxyAmplitudeEvent>>
>;
export type ProxyAmplitudeEventMutationError = ErrorType<unknown>;

export const useProxyAmplitudeEvent = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof proxyAmplitudeEvent>>,
    TError,
    string,
    AmplitudeAnalyticsReport,
    Awaited<ReturnType<typeof proxyAmplitudeEvent>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getProxyAmplitudeEventMutationKey();
  const swrFn = getProxyAmplitudeEventMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns a list of k8s clusters in the account
 */
export const listClusters = (
  params?: ListClustersParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CompoundListClustersResponse>(
    { url: `/clusters`, method: 'GET', params },
    options,
  );
};

export const getListClustersKey = (params?: ListClustersParams) =>
  [`/clusters`, ...(params ? [params] : [])] as const;

export type ListClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusters>>
>;
export type ListClustersQueryError = ErrorType<unknown>;

export const useListClusters = <TError = ErrorType<unknown>>(
  params?: ListClustersParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listClusters>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListClustersKey(params) : null));
  const swrFn = () => listClusters(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const createCluster = (
  createClusterRequest: BodyType<CreateClusterRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    {
      url: `/clusters`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClusterRequest,
    },
    options,
  );
};

export const getCreateClusterMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateClusterRequest },
  ): Promise<Cluster> => {
    return createCluster(arg, options);
  };
};
export const getCreateClusterMutationKey = () => `/clusters` as const;

export type CreateClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCluster>>
>;
export type CreateClusterMutationError = ErrorType<unknown>;

export const useCreateCluster = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createCluster>>,
    TError,
    string,
    CreateClusterRequest,
    Awaited<ReturnType<typeof createCluster>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateClusterMutationKey();
  const swrFn = getCreateClusterMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const deleteCluster = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/clusters/${clusterId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteClusterMutationFetcher = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteCluster(clusterId, options);
  };
};
export const getDeleteClusterMutationKey = (clusterId: string) =>
  `/clusters/${clusterId}` as const;

export type DeleteClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCluster>>
>;
export type DeleteClusterMutationError = ErrorType<unknown>;

export const useDeleteCluster = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteCluster>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteCluster>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteClusterMutationKey(clusterId);
  const swrFn = getDeleteClusterMutationFetcher(clusterId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getCluster = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    { url: `/clusters/${clusterId}`, method: 'GET' },
    options,
  );
};

export const getGetClusterKey = (clusterId: string) =>
  [`/clusters/${clusterId}`] as const;

export type GetClusterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCluster>>
>;
export type GetClusterQueryError = ErrorType<unknown>;

export const useGetCluster = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getCluster>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClusterKey(clusterId) : null));
  const swrFn = () => getCluster(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const updateCluster = (
  clusterId: string,
  updateClusterRequest: BodyType<UpdateClusterRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    {
      url: `/clusters/${clusterId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateClusterRequest,
    },
    options,
  );
};

export const getUpdateClusterMutationFetcher = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateClusterRequest },
  ): Promise<Cluster> => {
    return updateCluster(clusterId, arg, options);
  };
};
export const getUpdateClusterMutationKey = (clusterId: string) =>
  `/clusters/${clusterId}` as const;

export type UpdateClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCluster>>
>;
export type UpdateClusterMutationError = ErrorType<unknown>;

export const useUpdateCluster = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateCluster>>,
      TError,
      string,
      UpdateClusterRequest,
      Awaited<ReturnType<typeof updateCluster>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateClusterMutationKey(clusterId);
  const swrFn = getUpdateClusterMutationFetcher(clusterId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Return latest known node information for a cluster
 */
export const getClusterNodes = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ClusterNodesResponse>(
    { url: `/clusters/${clusterId}/nodes`, method: 'GET' },
    options,
  );
};

export const getGetClusterNodesKey = (clusterId: string) =>
  [`/clusters/${clusterId}/nodes`] as const;

export type GetClusterNodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClusterNodes>>
>;
export type GetClusterNodesQueryError = ErrorType<void>;

export const useGetClusterNodes = <TError = ErrorType<void>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getClusterNodes>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClusterNodesKey(clusterId) : null));
  const swrFn = () => getClusterNodes(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const listClusterScansWithArsigs = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScansResponse>(
    { url: `/clusters/${clusterId}/arsigs`, method: 'GET' },
    options,
  );
};

export const getListClusterScansWithArsigsKey = (clusterId: string) =>
  [`/clusters/${clusterId}/arsigs`] as const;

export type ListClusterScansWithArsigsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScansWithArsigs>>
>;
export type ListClusterScansWithArsigsQueryError = ErrorType<unknown>;

export const useListClusterScansWithArsigs = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScansWithArsigs>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListClusterScansWithArsigsKey(clusterId) : null));
  const swrFn = () => listClusterScansWithArsigs(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const listClusterScansWithLars = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScansResponse>(
    { url: `/clusters/${clusterId}/lars`, method: 'GET' },
    options,
  );
};

export const getListClusterScansWithLarsKey = (clusterId: string) =>
  [`/clusters/${clusterId}/lars`] as const;

export type ListClusterScansWithLarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScansWithLars>>
>;
export type ListClusterScansWithLarsQueryError = ErrorType<unknown>;

export const useListClusterScansWithLars = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScansWithLars>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListClusterScansWithLarsKey(clusterId) : null));
  const swrFn = () => listClusterScansWithLars(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the status of all LARs for a cluster
 */
export const listLARsStatus = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListLARsStatusResponse>(
    { url: `/clusters/${clusterId}/lars/status`, method: 'GET' },
    options,
  );
};

export const getListLARsStatusKey = (clusterId: string) =>
  [`/clusters/${clusterId}/lars/status`] as const;

export type ListLARsStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLARsStatus>>
>;
export type ListLARsStatusQueryError = ErrorType<unknown>;

export const useListLARsStatus = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listLARsStatus>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListLARsStatusKey(clusterId) : null));
  const swrFn = () => listLARsStatus(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the status of a specific LAR
 */
export const getLARStatus = (
  clusterId: string,
  larId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LARStatus>(
    { url: `/clusters/${clusterId}/lars/status/${larId}`, method: 'GET' },
    options,
  );
};

export const getGetLARStatusKey = (clusterId: string, larId: string) =>
  [`/clusters/${clusterId}/lars/status/${larId}`] as const;

export type GetLARStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLARStatus>>
>;
export type GetLARStatusQueryError = ErrorType<unknown>;

export const useGetLARStatus = <TError = ErrorType<unknown>>(
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getLARStatus>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(clusterId && larId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetLARStatusKey(clusterId, larId) : null));
  const swrFn = () => getLARStatus(clusterId, larId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update/Create LAR status
 */
export const updateLARStatus = (
  clusterId: string,
  larId: string,
  updateLARStatusRequest: BodyType<UpdateLARStatusRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LARStatus>(
    {
      url: `/clusters/${clusterId}/lars/status/${larId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateLARStatusRequest,
    },
    options,
  );
};

export const getUpdateLARStatusMutationFetcher = (
  clusterId: string,
  larId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateLARStatusRequest },
  ): Promise<LARStatus> => {
    return updateLARStatus(clusterId, larId, arg, options);
  };
};
export const getUpdateLARStatusMutationKey = (
  clusterId: string,
  larId: string,
) => `/clusters/${clusterId}/lars/status/${larId}` as const;

export type UpdateLARStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLARStatus>>
>;
export type UpdateLARStatusMutationError = ErrorType<unknown>;

export const useUpdateLARStatus = <TError = ErrorType<unknown>>(
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateLARStatus>>,
      TError,
      string,
      UpdateLARStatusRequest,
      Awaited<ReturnType<typeof updateLARStatus>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateLARStatusMutationKey(clusterId, larId);
  const swrFn = getUpdateLARStatusMutationFetcher(
    clusterId,
    larId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Ignore a specific LAR
 */
export const ignoreLAR = (
  clusterId: string,
  larId: string,
  ignoreLARRequest: BodyType<IgnoreLARRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LARStatus>(
    {
      url: `/clusters/${clusterId}/lars/status/${larId}/ignore`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: ignoreLARRequest,
    },
    options,
  );
};

export const getIgnoreLARMutationFetcher = (
  clusterId: string,
  larId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: IgnoreLARRequest },
  ): Promise<LARStatus> => {
    return ignoreLAR(clusterId, larId, arg, options);
  };
};
export const getIgnoreLARMutationKey = (clusterId: string, larId: string) =>
  `/clusters/${clusterId}/lars/status/${larId}/ignore` as const;

export type IgnoreLARMutationResult = NonNullable<
  Awaited<ReturnType<typeof ignoreLAR>>
>;
export type IgnoreLARMutationError = ErrorType<unknown>;

export const useIgnoreLAR = <TError = ErrorType<unknown>>(
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof ignoreLAR>>,
      TError,
      string,
      IgnoreLARRequest,
      Awaited<ReturnType<typeof ignoreLAR>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getIgnoreLARMutationKey(clusterId, larId);
  const swrFn = getIgnoreLARMutationFetcher(clusterId, larId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Acknowledge a specific LAR
 */
export const acknowledgeLAR = (
  clusterId: string,
  larId: string,
  acknowledgeLARRequest: BodyType<AcknowledgeLARRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LARStatus>(
    {
      url: `/clusters/${clusterId}/lars/status/${larId}/acknowledge`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: acknowledgeLARRequest,
    },
    options,
  );
};

export const getAcknowledgeLARMutationFetcher = (
  clusterId: string,
  larId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: AcknowledgeLARRequest },
  ): Promise<LARStatus> => {
    return acknowledgeLAR(clusterId, larId, arg, options);
  };
};
export const getAcknowledgeLARMutationKey = (
  clusterId: string,
  larId: string,
) => `/clusters/${clusterId}/lars/status/${larId}/acknowledge` as const;

export type AcknowledgeLARMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeLAR>>
>;
export type AcknowledgeLARMutationError = ErrorType<unknown>;

export const useAcknowledgeLAR = <TError = ErrorType<unknown>>(
  clusterId: string,
  larId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof acknowledgeLAR>>,
      TError,
      string,
      AcknowledgeLARRequest,
      Awaited<ReturnType<typeof acknowledgeLAR>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getAcknowledgeLARMutationKey(clusterId, larId);
  const swrFn = getAcknowledgeLARMutationFetcher(
    clusterId,
    larId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the scans of this cluster
 */
export const listClusterScans = (
  clusterId: string,
  params?: ListClusterScansParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScansResponseV2>(
    { url: `/clusters/${clusterId}/scans`, method: 'GET', params },
    options,
  );
};

export const getListClusterScansKey = (
  clusterId: string,
  params?: ListClusterScansParams,
) => [`/clusters/${clusterId}/scans`, ...(params ? [params] : [])] as const;

export type ListClusterScansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScans>>
>;
export type ListClusterScansQueryError = ErrorType<unknown>;

export const useListClusterScans = <TError = ErrorType<unknown>>(
  clusterId: string,
  params?: ListClusterScansParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScans>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListClusterScansKey(clusterId, params) : null));
  const swrFn = () => listClusterScans(clusterId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Return details about a specific scan of this cluster
 */
export const getClusterScan = (
  clusterId: string,
  scanId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ClusterScan>(
    { url: `/clusters/${clusterId}/scans/${scanId}`, method: 'GET' },
    options,
  );
};

export const getGetClusterScanKey = (clusterId: string, scanId: string) =>
  [`/clusters/${clusterId}/scans/${scanId}`] as const;

export type GetClusterScanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClusterScan>>
>;
export type GetClusterScanQueryError = ErrorType<unknown>;

export const useGetClusterScan = <TError = ErrorType<unknown>>(
  clusterId: string,
  scanId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getClusterScan>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(clusterId && scanId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClusterScanKey(clusterId, scanId) : null));
  const swrFn = () => getClusterScan(clusterId, scanId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the signatures of this scan
 */
export const listClusterScanSignatures = (
  clusterId: string,
  scanId: string,
  params?: ListClusterScanSignaturesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScanSignaturesResponse>(
    {
      url: `/clusters/${clusterId}/scans/${scanId}/signatures`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListClusterScanSignaturesKey = (
  clusterId: string,
  scanId: string,
  params?: ListClusterScanSignaturesParams,
) =>
  [
    `/clusters/${clusterId}/scans/${scanId}/signatures`,
    ...(params ? [params] : []),
  ] as const;

export type ListClusterScanSignaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScanSignatures>>
>;
export type ListClusterScanSignaturesQueryError = ErrorType<unknown>;

export const useListClusterScanSignatures = <TError = ErrorType<unknown>>(
  clusterId: string,
  scanId: string,
  params?: ListClusterScanSignaturesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScanSignatures>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(clusterId && scanId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListClusterScanSignaturesKey(clusterId, scanId, params)
        : null);
  const swrFn = () =>
    listClusterScanSignatures(clusterId, scanId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the LARs of this scan
 */
export const listClusterScanLARs = (
  clusterId: string,
  scanId: string,
  params?: ListClusterScanLARsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScanLARsResponse>(
    {
      url: `/clusters/${clusterId}/scans/${scanId}/lars`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListClusterScanLARsKey = (
  clusterId: string,
  scanId: string,
  params?: ListClusterScanLARsParams,
) =>
  [
    `/clusters/${clusterId}/scans/${scanId}/lars`,
    ...(params ? [params] : []),
  ] as const;

export type ListClusterScanLARsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScanLARs>>
>;
export type ListClusterScanLARsQueryError = ErrorType<unknown>;

export const useListClusterScanLARs = <TError = ErrorType<unknown>>(
  clusterId: string,
  scanId: string,
  params?: ListClusterScanLARsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScanLARs>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(clusterId && scanId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListClusterScanLARsKey(clusterId, scanId, params) : null);
  const swrFn = () =>
    listClusterScanLARs(clusterId, scanId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Return details about a specific LAR of this scan
 */
export const getClusterScanLAR = (
  clusterId: string,
  scanId: string,
  larId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ClusterDetectedLar>(
    {
      url: `/clusters/${clusterId}/scans/${scanId}/lars/${larId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetClusterScanLARKey = (
  clusterId: string,
  scanId: string,
  larId: string,
) => [`/clusters/${clusterId}/scans/${scanId}/lars/${larId}`] as const;

export type GetClusterScanLARQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClusterScanLAR>>
>;
export type GetClusterScanLARQueryError = ErrorType<unknown>;

export const useGetClusterScanLAR = <TError = ErrorType<unknown>>(
  clusterId: string,
  scanId: string,
  larId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getClusterScanLAR>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(clusterId && scanId && larId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetClusterScanLARKey(clusterId, scanId, larId) : null);
  const swrFn = () =>
    getClusterScanLAR(clusterId, scanId, larId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the resources of a specific LAR of this scan
 */
export const listClusterScanLARResources = (
  clusterId: string,
  scanId: string,
  larId: string,
  params?: ListClusterScanLARResourcesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListClusterScanLARResourcesResponse>(
    {
      url: `/clusters/${clusterId}/scans/${scanId}/lars/${larId}/resources`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListClusterScanLARResourcesKey = (
  clusterId: string,
  scanId: string,
  larId: string,
  params?: ListClusterScanLARResourcesParams,
) =>
  [
    `/clusters/${clusterId}/scans/${scanId}/lars/${larId}/resources`,
    ...(params ? [params] : []),
  ] as const;

export type ListClusterScanLARResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClusterScanLARResources>>
>;
export type ListClusterScanLARResourcesQueryError = ErrorType<unknown>;

export const useListClusterScanLARResources = <TError = ErrorType<unknown>>(
  clusterId: string,
  scanId: string,
  larId: string,
  params?: ListClusterScanLARResourcesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listClusterScanLARResources>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(clusterId && scanId && larId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListClusterScanLARResourcesKey(clusterId, scanId, larId, params)
        : null);
  const swrFn = () =>
    listClusterScanLARResources(
      clusterId,
      scanId,
      larId,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getClusterRescanState = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    { url: `/clusters/${clusterId}/rescan`, method: 'GET' },
    options,
  );
};

export const getGetClusterRescanStateKey = (clusterId: string) =>
  [`/clusters/${clusterId}/rescan`] as const;

export type GetClusterRescanStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClusterRescanState>>
>;
export type GetClusterRescanStateQueryError = ErrorType<unknown>;

export const useGetClusterRescanState = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getClusterRescanState>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!clusterId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClusterRescanStateKey(clusterId) : null));
  const swrFn = () => getClusterRescanState(clusterId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const rescanCluster = (
  clusterId: string,
  rescanClusterRequest: BodyType<RescanClusterRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    {
      url: `/clusters/${clusterId}/rescan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: rescanClusterRequest,
    },
    options,
  );
};

export const getRescanClusterMutationFetcher = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: RescanClusterRequest },
  ): Promise<Cluster> => {
    return rescanCluster(clusterId, arg, options);
  };
};
export const getRescanClusterMutationKey = (clusterId: string) =>
  `/clusters/${clusterId}/rescan` as const;

export type RescanClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescanCluster>>
>;
export type RescanClusterMutationError = ErrorType<unknown>;

export const useRescanCluster = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof rescanCluster>>,
      TError,
      string,
      RescanClusterRequest,
      Awaited<ReturnType<typeof rescanCluster>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRescanClusterMutationKey(clusterId);
  const swrFn = getRescanClusterMutationFetcher(clusterId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const createClusterScan = (
  clusterId: string,
  createClusterScanRequest: BodyType<CreateClusterScanRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Cluster>(
    {
      url: `/clusters/${clusterId}/scan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClusterScanRequest,
    },
    options,
  );
};

export const getCreateClusterScanMutationFetcher = (
  clusterId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateClusterScanRequest },
  ): Promise<Cluster> => {
    return createClusterScan(clusterId, arg, options);
  };
};
export const getCreateClusterScanMutationKey = (clusterId: string) =>
  `/clusters/${clusterId}/scan` as const;

export type CreateClusterScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClusterScan>>
>;
export type CreateClusterScanMutationError = ErrorType<unknown>;

export const useCreateClusterScan = <TError = ErrorType<unknown>>(
  clusterId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createClusterScan>>,
      TError,
      string,
      CreateClusterScanRequest,
      Awaited<ReturnType<typeof createClusterScan>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateClusterScanMutationKey(clusterId);
  const swrFn = getCreateClusterScanMutationFetcher(clusterId, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Endpoint for reporting feedback about Chkk of different nature - user sign-up requests, k8s questions or general feedback
 */
export const submitFeedback = (
  submitFeedbackRequest: BodyType<SubmitFeedbackRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SubmitFeedbackResponse>(
    {
      url: `/feedbacks`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: submitFeedbackRequest,
    },
    options,
  );
};

export const getSubmitFeedbackMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: SubmitFeedbackRequest },
  ): Promise<SubmitFeedbackResponse> => {
    return submitFeedback(arg, options);
  };
};
export const getSubmitFeedbackMutationKey = () => `/feedbacks` as const;

export type SubmitFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitFeedback>>
>;
export type SubmitFeedbackMutationError = ErrorType<unknown>;

export const useSubmitFeedback = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitFeedback>>,
    TError,
    string,
    SubmitFeedbackRequest,
    Awaited<ReturnType<typeof submitFeedback>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitFeedbackMutationKey();
  const swrFn = getSubmitFeedbackMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the integrations configured in the Chkk account
 */
export const listIntegrations = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListIntegrationsResponse>(
    { url: `/integrations`, method: 'GET' },
    options,
  );
};

export const getListIntegrationsKey = () => [`/integrations`] as const;

export type ListIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIntegrations>>
>;
export type ListIntegrationsQueryError = ErrorType<unknown>;

export const useListIntegrations = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof listIntegrations>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListIntegrationsKey() : null));
  const swrFn = () => listIntegrations(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new integration in the Chkk account
 */
export const createIntegration = (
  createIntegrationRequest: BodyType<CreateIntegrationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Integration>(
    {
      url: `/integrations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createIntegrationRequest,
    },
    options,
  );
};

export const getCreateIntegrationMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateIntegrationRequest },
  ): Promise<Integration> => {
    return createIntegration(arg, options);
  };
};
export const getCreateIntegrationMutationKey = () => `/integrations` as const;

export type CreateIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createIntegration>>
>;
export type CreateIntegrationMutationError = ErrorType<unknown>;

export const useCreateIntegration = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createIntegration>>,
    TError,
    string,
    CreateIntegrationRequest,
    Awaited<ReturnType<typeof createIntegration>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateIntegrationMutationKey();
  const swrFn = getCreateIntegrationMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getPrometheusMetricsScrape = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/integrations/prometheus/metrics`, method: 'GET' },
    options,
  );
};

export const getGetPrometheusMetricsScrapeKey = () =>
  [`/integrations/prometheus/metrics`] as const;

export type GetPrometheusMetricsScrapeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrometheusMetricsScrape>>
>;
export type GetPrometheusMetricsScrapeQueryError = ErrorType<unknown>;

export const useGetPrometheusMetricsScrape = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getPrometheusMetricsScrape>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPrometheusMetricsScrapeKey() : null));
  const swrFn = () => getPrometheusMetricsScrape(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getPrometheusStatus = (
  params: GetPrometheusStatusParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/integrations/prometheus/status`, method: 'GET', params },
    options,
  );
};

export const getGetPrometheusStatusKey = (params: GetPrometheusStatusParams) =>
  [`/integrations/prometheus/status`, ...(params ? [params] : [])] as const;

export type GetPrometheusStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrometheusStatus>>
>;
export type GetPrometheusStatusQueryError = ErrorType<unknown>;

export const useGetPrometheusStatus = <TError = ErrorType<unknown>>(
  params: GetPrometheusStatusParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getPrometheusStatus>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPrometheusStatusKey(params) : null));
  const swrFn = () => getPrometheusStatus(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete an existing integration from the Chkk account
 */
export const deleteIntegration = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/integrations/${integrationId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteIntegrationMutationFetcher = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteIntegration(integrationId, options);
  };
};
export const getDeleteIntegrationMutationKey = (integrationId: string) =>
  `/integrations/${integrationId}` as const;

export type DeleteIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntegration>>
>;
export type DeleteIntegrationMutationError = ErrorType<unknown>;

export const useDeleteIntegration = <TError = ErrorType<unknown>>(
  integrationId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteIntegration>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteIntegration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getDeleteIntegrationMutationKey(integrationId);
  const swrFn = getDeleteIntegrationMutationFetcher(
    integrationId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the details of an existing integration
 */
export const getIntegration = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Integration>(
    { url: `/integrations/${integrationId}`, method: 'GET' },
    options,
  );
};

export const getGetIntegrationKey = (integrationId: string) =>
  [`/integrations/${integrationId}`] as const;

export type GetIntegrationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegration>>
>;
export type GetIntegrationQueryError = ErrorType<unknown>;

export const useGetIntegration = <TError = ErrorType<unknown>>(
  integrationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getIntegration>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!integrationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetIntegrationKey(integrationId) : null));
  const swrFn = () => getIntegration(integrationId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update an existing integration (e.g. with new status)
 */
export const updateIntegration = (
  integrationId: string,
  updateIntegrationRequest: BodyType<UpdateIntegrationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Integration>(
    {
      url: `/integrations/${integrationId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateIntegrationRequest,
    },
    options,
  );
};

export const getUpdateIntegrationMutationFetcher = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateIntegrationRequest },
  ): Promise<Integration> => {
    return updateIntegration(integrationId, arg, options);
  };
};
export const getUpdateIntegrationMutationKey = (integrationId: string) =>
  `/integrations/${integrationId}` as const;

export type UpdateIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateIntegration>>
>;
export type UpdateIntegrationMutationError = ErrorType<unknown>;

export const useUpdateIntegration = <TError = ErrorType<unknown>>(
  integrationId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateIntegration>>,
      TError,
      string,
      UpdateIntegrationRequest,
      Awaited<ReturnType<typeof updateIntegration>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateIntegrationMutationKey(integrationId);
  const swrFn = getUpdateIntegrationMutationFetcher(
    integrationId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve the alert manager configuration snippet for the referenced integration
 */
export const getIntegrationAlertManagerConfig = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/integrations/${integrationId}/alert_manager_config`,
      method: 'GET',
    },
    options,
  );
};

export const getGetIntegrationAlertManagerConfigKey = (integrationId: string) =>
  [`/integrations/${integrationId}/alert_manager_config`] as const;

export type GetIntegrationAlertManagerConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationAlertManagerConfig>>
>;
export type GetIntegrationAlertManagerConfigQueryError = ErrorType<unknown>;

export const useGetIntegrationAlertManagerConfig = <
  TError = ErrorType<unknown>,
>(
  integrationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getIntegrationAlertManagerConfig>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!integrationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetIntegrationAlertManagerConfigKey(integrationId) : null);
  const swrFn = () =>
    getIntegrationAlertManagerConfig(integrationId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get ticket details
 */
export const getTicketDetails = (
  integrationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetTicketDetailsResponse>(
    { url: `/integrations/${integrationId}/ticket_details`, method: 'GET' },
    options,
  );
};

export const getGetTicketDetailsKey = (integrationId: string) =>
  [`/integrations/${integrationId}/ticket_details`] as const;

export type GetTicketDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTicketDetails>>
>;
export type GetTicketDetailsQueryError = ErrorType<unknown>;

export const useGetTicketDetails = <TError = ErrorType<unknown>>(
  integrationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getTicketDetails>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!integrationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetTicketDetailsKey(integrationId) : null));
  const swrFn = () => getTicketDetails(integrationId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getKba = (
  arsigId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/kbas/${arsigId}`, method: 'GET' },
    options,
  );
};

export const getGetKbaKey = (arsigId: string) => [`/kbas/${arsigId}`] as const;

export type GetKbaQueryResult = NonNullable<Awaited<ReturnType<typeof getKba>>>;
export type GetKbaQueryError = ErrorType<unknown>;

export const useGetKba = <TError = ErrorType<unknown>>(
  arsigId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getKba>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!arsigId;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetKbaKey(arsigId) : null));
  const swrFn = () => getKba(arsigId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getLarOverview = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LarsOverviewResponse>(
    { url: `/larsoverview`, method: 'GET' },
    options,
  );
};

export const getGetLarOverviewKey = () => [`/larsoverview`] as const;

export type GetLarOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLarOverview>>
>;
export type GetLarOverviewQueryError = ErrorType<unknown>;

export const useGetLarOverview = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof getLarOverview>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetLarOverviewKey() : null));
  const swrFn = () => getLarOverview(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Login the provided user, and make sure their core data structures are ready for use (e.g. that they have an account setup for them)
 */
export const login = (
  params?: LoginParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<LoginResponse>(
    { url: `/login`, method: 'POST', params },
    options,
  );
};

export const getLoginMutationFetcher = (
  params?: LoginParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<LoginResponse> => {
    return login(params, options);
  };
};
export const getLoginMutationKey = () => `/login` as const;

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationError = ErrorType<unknown>;

export const useLogin = <TError = ErrorType<unknown>>(
  params?: LoginParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof login>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof login>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getLoginMutationKey();
  const swrFn = getLoginMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Creates a subscription request from GCP Marketplace for the Chkk product.
The request will be reviewed and either approved or rejected by the backend.

 */
export const createGcpMarketplaceSubscription = (
  gcpMarketplaceSubscriptionRequest: BodyType<GcpMarketplaceSubscriptionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GcpMarketplaceSubscriptionResponse>(
    {
      url: `/subscriptions/gcp-marketplace`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: gcpMarketplaceSubscriptionRequest,
    },
    options,
  );
};

export const getCreateGcpMarketplaceSubscriptionMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: GcpMarketplaceSubscriptionRequest },
  ): Promise<GcpMarketplaceSubscriptionResponse> => {
    return createGcpMarketplaceSubscription(arg, options);
  };
};
export const getCreateGcpMarketplaceSubscriptionMutationKey = () =>
  `/subscriptions/gcp-marketplace` as const;

export type CreateGcpMarketplaceSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGcpMarketplaceSubscription>>
>;
export type CreateGcpMarketplaceSubscriptionMutationError = ErrorType<unknown>;

export const useCreateGcpMarketplaceSubscription = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createGcpMarketplaceSubscription>>,
    TError,
    string,
    GcpMarketplaceSubscriptionRequest,
    Awaited<ReturnType<typeof createGcpMarketplaceSubscription>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateGcpMarketplaceSubscriptionMutationKey();
  const swrFn =
    getCreateGcpMarketplaceSubscriptionMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new organization with the calling user as sole member
 */
export const createOrganization = (
  createOrganizationRequest: BodyType<CreateOrganizationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Organization>(
    {
      url: `/orgs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createOrganizationRequest,
    },
    options,
  );
};

export const getCreateOrganizationMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateOrganizationRequest },
  ): Promise<Organization> => {
    return createOrganization(arg, options);
  };
};
export const getCreateOrganizationMutationKey = () => `/orgs` as const;

export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationError = ErrorType<unknown>;

export const useCreateOrganization = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    string,
    CreateOrganizationRequest,
    Awaited<ReturnType<typeof createOrganization>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateOrganizationMutationKey();
  const swrFn = getCreateOrganizationMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the details for a specific organization
 */
export const getOrganization = (
  orgSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Organization>(
    { url: `/orgs/${orgSlug}`, method: 'GET' },
    options,
  );
};

export const getGetOrganizationKey = (orgSlug: string) =>
  [`/orgs/${orgSlug}`] as const;

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = ErrorType<unknown>;

export const useGetOrganization = <TError = ErrorType<unknown>>(
  orgSlug: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getOrganization>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!orgSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetOrganizationKey(orgSlug) : null));
  const swrFn = () => getOrganization(orgSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update the details of a specific organization (e.g. the displayed name)
 */
export const updateOrganization = (
  orgSlug: string,
  updateOrganizationRequest: BodyType<UpdateOrganizationRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Organization>(
    {
      url: `/orgs/${orgSlug}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateOrganizationRequest,
    },
    options,
  );
};

export const getUpdateOrganizationMutationFetcher = (
  orgSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateOrganizationRequest },
  ): Promise<Organization> => {
    return updateOrganization(orgSlug, arg, options);
  };
};
export const getUpdateOrganizationMutationKey = (orgSlug: string) =>
  `/orgs/${orgSlug}` as const;

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationError = ErrorType<unknown>;

export const useUpdateOrganization = <TError = ErrorType<unknown>>(
  orgSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateOrganization>>,
      TError,
      string,
      UpdateOrganizationRequest,
      Awaited<ReturnType<typeof updateOrganization>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateOrganizationMutationKey(orgSlug);
  const swrFn = getUpdateOrganizationMutationFetcher(orgSlug, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the subscriptions associated with a Chkk organization
 */
export const listSubscriptions = (
  orgSlug: string,
  params?: ListSubscriptionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListSubscriptionsResponse>(
    { url: `/orgs/${orgSlug}/subscriptions`, method: 'GET', params },
    options,
  );
};

export const getListSubscriptionsKey = (
  orgSlug: string,
  params?: ListSubscriptionsParams,
) => [`/orgs/${orgSlug}/subscriptions`, ...(params ? [params] : [])] as const;

export type ListSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptions>>
>;
export type ListSubscriptionsQueryError = ErrorType<unknown>;

export const useListSubscriptions = <TError = ErrorType<unknown>>(
  orgSlug: string,
  params?: ListSubscriptionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listSubscriptions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!orgSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListSubscriptionsKey(orgSlug, params) : null));
  const swrFn = () => listSubscriptions(orgSlug, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Add a new subscription to the account
 */
export const createSubscription = (
  orgSlug: string,
  createSubscriptionRequest: BodyType<CreateSubscriptionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CreateSubscriptionResponse>(
    {
      url: `/orgs/${orgSlug}/subscriptions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSubscriptionRequest,
    },
    options,
  );
};

export const getCreateSubscriptionMutationFetcher = (
  orgSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateSubscriptionRequest },
  ): Promise<CreateSubscriptionResponse> => {
    return createSubscription(orgSlug, arg, options);
  };
};
export const getCreateSubscriptionMutationKey = (orgSlug: string) =>
  `/orgs/${orgSlug}/subscriptions` as const;

export type CreateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>;
export type CreateSubscriptionMutationError = ErrorType<unknown>;

export const useCreateSubscription = <TError = ErrorType<unknown>>(
  orgSlug: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createSubscription>>,
      TError,
      string,
      CreateSubscriptionRequest,
      Awaited<ReturnType<typeof createSubscription>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateSubscriptionMutationKey(orgSlug);
  const swrFn = getCreateSubscriptionMutationFetcher(orgSlug, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve the details of a specific subscription
 */
export const getSubscription = (
  orgSlug: string,
  subscriptionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ResolvedSubscription>(
    { url: `/orgs/${orgSlug}/subscriptions/${subscriptionId}`, method: 'GET' },
    options,
  );
};

export const getGetSubscriptionKey = (
  orgSlug: string,
  subscriptionId: string,
) => [`/orgs/${orgSlug}/subscriptions/${subscriptionId}`] as const;

export type GetSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscription>>
>;
export type GetSubscriptionQueryError = ErrorType<unknown>;

export const useGetSubscription = <TError = ErrorType<unknown>>(
  orgSlug: string,
  subscriptionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSubscription>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(orgSlug && subscriptionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSubscriptionKey(orgSlug, subscriptionId) : null));
  const swrFn = () => getSubscription(orgSlug, subscriptionId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update the properties of a specific subscription
 */
export const updateSubscription = (
  orgSlug: string,
  subscriptionId: string,
  updateSubscriptionRequest: BodyType<UpdateSubscriptionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/orgs/${orgSlug}/subscriptions/${subscriptionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSubscriptionRequest,
    },
    options,
  );
};

export const getUpdateSubscriptionMutationFetcher = (
  orgSlug: string,
  subscriptionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateSubscriptionRequest },
  ): Promise<void> => {
    return updateSubscription(orgSlug, subscriptionId, arg, options);
  };
};
export const getUpdateSubscriptionMutationKey = (
  orgSlug: string,
  subscriptionId: string,
) => `/orgs/${orgSlug}/subscriptions/${subscriptionId}` as const;

export type UpdateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscription>>
>;
export type UpdateSubscriptionMutationError = ErrorType<unknown>;

export const useUpdateSubscription = <TError = ErrorType<unknown>>(
  orgSlug: string,
  subscriptionId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateSubscription>>,
      TError,
      string,
      UpdateSubscriptionRequest,
      Awaited<ReturnType<typeof updateSubscription>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateSubscriptionMutationKey(orgSlug, subscriptionId);
  const swrFn = getUpdateSubscriptionMutationFetcher(
    orgSlug,
    subscriptionId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the access tokens for the different accounts in the Chkk organization (for the calling user)
 */
export const listAccessTokens = (
  orgSlug: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAccessTokensResponse>(
    { url: `/orgs/${orgSlug}/tokens`, method: 'GET' },
    options,
  );
};

export const getListAccessTokensKey = (orgSlug: string) =>
  [`/orgs/${orgSlug}/tokens`] as const;

export type ListAccessTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccessTokens>>
>;
export type ListAccessTokensQueryError = ErrorType<unknown>;

export const useListAccessTokens = <TError = ErrorType<unknown>>(
  orgSlug: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAccessTokens>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!orgSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAccessTokensKey(orgSlug) : null));
  const swrFn = () => listAccessTokens(orgSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get the ingestion token for the account
 * @deprecated
 */
export const getIngestionToken = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetIngestionTokenResponse>(
    { url: `/ingestion_scopes/${id}/token`, method: 'GET' },
    options,
  );
};

export const getGetIngestionTokenKey = (id: string) =>
  [`/ingestion_scopes/${id}/token`] as const;

export type GetIngestionTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIngestionToken>>
>;
export type GetIngestionTokenQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useGetIngestionToken = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getIngestionToken>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetIngestionTokenKey(id) : null));
  const swrFn = () => getIngestionToken(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the ingestion token for the account
 */
export const listIngestionTokens = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListIngestionTokensResponse>(
    { url: `/ingestion_scopes/${id}/tokens`, method: 'GET' },
    options,
  );
};

export const getListIngestionTokensKey = (id: string) =>
  [`/ingestion_scopes/${id}/tokens`] as const;

export type ListIngestionTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIngestionTokens>>
>;
export type ListIngestionTokensQueryError = ErrorType<unknown>;

export const useListIngestionTokens = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listIngestionTokens>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListIngestionTokensKey(id) : null));
  const swrFn = () => listIngestionTokens(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create an ingestion token for the account
 */
export const createIngestionToken = (
  id: string,
  createIngestionTokenRequest: BodyType<CreateIngestionTokenRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<IngestionToken>(
    {
      url: `/ingestion_scopes/${id}/tokens`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createIngestionTokenRequest,
    },
    options,
  );
};

export const getCreateIngestionTokenMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateIngestionTokenRequest },
  ): Promise<IngestionToken> => {
    return createIngestionToken(id, arg, options);
  };
};
export const getCreateIngestionTokenMutationKey = (id: string) =>
  `/ingestion_scopes/${id}/tokens` as const;

export type CreateIngestionTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createIngestionToken>>
>;
export type CreateIngestionTokenMutationError = ErrorType<unknown>;

export const useCreateIngestionToken = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createIngestionToken>>,
      TError,
      string,
      CreateIngestionTokenRequest,
      Awaited<ReturnType<typeof createIngestionToken>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateIngestionTokenMutationKey(id);
  const swrFn = getCreateIngestionTokenMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete the ingestion token
 */
export const deleteIngestionToken = (
  id: string,
  tokenId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/ingestion_scopes/${id}/tokens/${tokenId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteIngestionTokenMutationFetcher = (
  id: string,
  tokenId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteIngestionToken(id, tokenId, options);
  };
};
export const getDeleteIngestionTokenMutationKey = (
  id: string,
  tokenId: string,
) => `/ingestion_scopes/${id}/tokens/${tokenId}` as const;

export type DeleteIngestionTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIngestionToken>>
>;
export type DeleteIngestionTokenMutationError = ErrorType<unknown>;

export const useDeleteIngestionToken = <TError = ErrorType<unknown>>(
  id: string,
  tokenId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteIngestionToken>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteIngestionToken>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getDeleteIngestionTokenMutationKey(id, tokenId);
  const swrFn = getDeleteIngestionTokenMutationFetcher(
    id,
    tokenId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update the details of an Ingestion Token (e.g. change name, revoke token, etc.)
 */
export const updateIngestionToken = (
  id: string,
  tokenId: string,
  updateIngestionTokenRequest: BodyType<UpdateIngestionTokenRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<IngestionToken>(
    {
      url: `/ingestion_scopes/${id}/tokens/${tokenId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateIngestionTokenRequest,
    },
    options,
  );
};

export const getUpdateIngestionTokenMutationFetcher = (
  id: string,
  tokenId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateIngestionTokenRequest },
  ): Promise<IngestionToken> => {
    return updateIngestionToken(id, tokenId, arg, options);
  };
};
export const getUpdateIngestionTokenMutationKey = (
  id: string,
  tokenId: string,
) => `/ingestion_scopes/${id}/tokens/${tokenId}` as const;

export type UpdateIngestionTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateIngestionToken>>
>;
export type UpdateIngestionTokenMutationError = ErrorType<unknown>;

export const useUpdateIngestionToken = <TError = ErrorType<unknown>>(
  id: string,
  tokenId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateIngestionToken>>,
      TError,
      string,
      UpdateIngestionTokenRequest,
      Awaited<ReturnType<typeof updateIngestionToken>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateIngestionTokenMutationKey(id, tokenId);
  const swrFn = getUpdateIngestionTokenMutationFetcher(
    id,
    tokenId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const getQuickStartState = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<QuickStartResponse>(
    { url: `/quick-start`, method: 'GET' },
    options,
  );
};

export const getGetQuickStartStateKey = () => [`/quick-start`] as const;

export type GetQuickStartStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuickStartState>>
>;
export type GetQuickStartStateQueryError = ErrorType<unknown>;

export const useGetQuickStartState = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getQuickStartState>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuickStartStateKey() : null));
  const swrFn = () => getQuickStartState(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 * @deprecated
 */
export const listScans = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<ListClusterScansResponse>(
    { url: `/scans`, method: 'GET' },
    options,
  );
};

export const getListScansKey = () => [`/scans`] as const;

export type ListScansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScans>>
>;
export type ListScansQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useListScans = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof listScans>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListScansKey() : null));
  const swrFn = () => listScans(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 * @deprecated
 */
export const createScan = (
  createScanRequest: BodyType<CreateScanRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CreateScanResponse>(
    {
      url: `/scans`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createScanRequest,
    },
    options,
  );
};

export const getCreateScanMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateScanRequest },
  ): Promise<CreateScanResponse> => {
    return createScan(arg, options);
  };
};
export const getCreateScanMutationKey = () => `/scans` as const;

export type CreateScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createScan>>
>;
export type CreateScanMutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useCreateScan = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createScan>>,
    TError,
    string,
    CreateScanRequest,
    Awaited<ReturnType<typeof createScan>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateScanMutationKey();
  const swrFn = getCreateScanMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Endpoint for the Sentry tunnel used by the web apps to report issues.

See https://docs.sentry.io/platforms/javascript/troubleshooting/#using-the-tunnel-option for more details.

The requests are in POST form, and consist of 3 lines with the first being a form of header containing the DSN of the report. The other lines report metadata as well as the stacktrace/breadcrumbs.

 */
export const proxySentryReport = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/sentry-proxy`, method: 'POST' },
    options,
  );
};

export const getProxySentryReportMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<unknown> => {
    return proxySentryReport(options);
  };
};
export const getProxySentryReportMutationKey = () => `/sentry-proxy` as const;

export type ProxySentryReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof proxySentryReport>>
>;
export type ProxySentryReportMutationError = ErrorType<unknown>;

export const useProxySentryReport = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof proxySentryReport>>,
    TError,
    string,
    Arguments,
    Awaited<ReturnType<typeof proxySentryReport>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getProxySentryReportMutationKey();
  const swrFn = getProxySentryReportMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * ???
 */
export const createTicket = (
  createTicketRequest: BodyType<CreateTicketRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/tickets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTicketRequest,
    },
    options,
  );
};

export const getCreateTicketMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateTicketRequest },
  ): Promise<unknown> => {
    return createTicket(arg, options);
  };
};
export const getCreateTicketMutationKey = () => `/tickets` as const;

export type CreateTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTicket>>
>;
export type CreateTicketMutationError = ErrorType<unknown>;

export const useCreateTicket = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createTicket>>,
    TError,
    string,
    CreateTicketRequest,
    Awaited<ReturnType<typeof createTicket>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateTicketMutationKey();
  const swrFn = getCreateTicketMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get details of the calling user
 */
export const getUsers = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<GetUsersResponse>(
    { url: `/users`, method: 'GET' },
    options,
  );
};

export const getGetUsersKey = () => [`/users`] as const;

export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = ErrorType<unknown>;

export const useGetUsers = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof getUsers>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetUsersKey() : null));
  const swrFn = () => getUsers(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List addons known to Chkk
 */
export const listDirectoryAddons = (
  params?: ListDirectoryAddonsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListDirectoryAddonsResponse>(
    { url: `/directory/addons`, method: 'GET', params },
    options,
  );
};

export const getListDirectoryAddonsKey = (params?: ListDirectoryAddonsParams) =>
  [`/directory/addons`, ...(params ? [params] : [])] as const;

export type ListDirectoryAddonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDirectoryAddons>>
>;
export type ListDirectoryAddonsQueryError = ErrorType<unknown>;

export const useListDirectoryAddons = <TError = ErrorType<unknown>>(
  params?: ListDirectoryAddonsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listDirectoryAddons>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListDirectoryAddonsKey(params) : null));
  const swrFn = () => listDirectoryAddons(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List instances of addons found in clusters in the account
 */
export const listAddonInstances = (
  params?: ListAddonInstancesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAddonInstancesResponse>(
    { url: `/addon_instances`, method: 'GET', params },
    options,
  );
};

export const getListAddonInstancesKey = (params?: ListAddonInstancesParams) =>
  [`/addon_instances`, ...(params ? [params] : [])] as const;

export type ListAddonInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAddonInstances>>
>;
export type ListAddonInstancesQueryError = ErrorType<unknown>;

export const useListAddonInstances = <TError = ErrorType<unknown>>(
  params?: ListAddonInstancesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAddonInstances>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAddonInstancesKey(params) : null));
  const swrFn = () => listAddonInstances(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve details about a specific addon instance
 */
export const getAddonInstance = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AddonInstance>(
    { url: `/addon_instances/${id}`, method: 'GET' },
    options,
  );
};

export const getGetAddonInstanceKey = (id: string) =>
  [`/addon_instances/${id}`] as const;

export type GetAddonInstanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddonInstance>>
>;
export type GetAddonInstanceQueryError = ErrorType<unknown>;

export const useGetAddonInstance = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAddonInstance>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAddonInstanceKey(id) : null));
  const swrFn = () => getAddonInstance(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve the resources of a specific addon instance
 */
export const listAddonInstanceResources = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAddonInstanceResourcesResponse>(
    { url: `/addon_instances/${id}/resources`, method: 'GET' },
    options,
  );
};

export const getListAddonInstanceResourcesKey = (id: string) =>
  [`/addon_instances/${id}/resources`] as const;

export type ListAddonInstanceResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAddonInstanceResources>>
>;
export type ListAddonInstanceResourcesQueryError = ErrorType<unknown>;

export const useListAddonInstanceResources = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAddonInstanceResources>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAddonInstanceResourcesKey(id) : null));
  const swrFn = () => listAddonInstanceResources(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the AvailabilityRisks in the account, filtered by the query parameters
 */
export const listAvailabilityRisks = (
  params?: ListAvailabilityRisksParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAvailabilityRisksResponse>(
    { url: `/availability_risks`, method: 'GET', params },
    options,
  );
};

export const getListAvailabilityRisksKey = (
  params?: ListAvailabilityRisksParams,
) => [`/availability_risks`, ...(params ? [params] : [])] as const;

export type ListAvailabilityRisksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailabilityRisks>>
>;
export type ListAvailabilityRisksQueryError = ErrorType<unknown>;

export const useListAvailabilityRisks = <TError = ErrorType<unknown>>(
  params?: ListAvailabilityRisksParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listAvailabilityRisks>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListAvailabilityRisksKey(params) : null));
  const swrFn = () => listAvailabilityRisks(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Return aggregate counts for the AvailabilityRisks in the account, filtered and grouped by the query parameters
 */
export const getAvailabilityRisksSummary = (
  params: GetAvailabilityRisksSummaryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AvailabilityRisksSummary>(
    { url: `/availability_risks/summary`, method: 'GET', params },
    options,
  );
};

export const getGetAvailabilityRisksSummaryKey = (
  params: GetAvailabilityRisksSummaryParams,
) => [`/availability_risks/summary`, ...(params ? [params] : [])] as const;

export type GetAvailabilityRisksSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityRisksSummary>>
>;
export type GetAvailabilityRisksSummaryQueryError = ErrorType<unknown>;

export const useGetAvailabilityRisksSummary = <TError = ErrorType<unknown>>(
  params: GetAvailabilityRisksSummaryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAvailabilityRisksSummary>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAvailabilityRisksSummaryKey(params) : null));
  const swrFn = () => getAvailabilityRisksSummary(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the resourcs in this account affected by the AvailabilityRisk
 */
export const getAvailabilityRiskAffectedResource = (
  availabilityRiskId: string,
  params?: GetAvailabilityRiskAffectedResourceParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAffectedResourcesResponse>(
    {
      url: `/availability_risks/${availabilityRiskId}/affected_resources`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getGetAvailabilityRiskAffectedResourceKey = (
  availabilityRiskId: string,
  params?: GetAvailabilityRiskAffectedResourceParams,
) =>
  [
    `/availability_risks/${availabilityRiskId}/affected_resources`,
    ...(params ? [params] : []),
  ] as const;

export type GetAvailabilityRiskAffectedResourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityRiskAffectedResource>>
>;
export type GetAvailabilityRiskAffectedResourceQueryError = ErrorType<unknown>;

export const useGetAvailabilityRiskAffectedResource = <
  TError = ErrorType<unknown>,
>(
  availabilityRiskId: string,
  params?: GetAvailabilityRiskAffectedResourceParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAvailabilityRiskAffectedResource>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!availabilityRiskId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetAvailabilityRiskAffectedResourceKey(availabilityRiskId, params)
        : null);
  const swrFn = () =>
    getAvailabilityRiskAffectedResource(
      availabilityRiskId,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns the requested diff for changes between two versions of this package. This can cover changes to the CRDs, non-CRD resources as well as Helm Values (if it's a Helm package)
 * @summary Get a diff of the changes between two versions of the package
 */
export const getPackageDiff = (
  id: string,
  params: GetPackageDiffParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/packages/${id}/diff`, method: 'GET', params },
    options,
  );
};

export const getGetPackageDiffKey = (
  id: string,
  params: GetPackageDiffParams,
) => [`/packages/${id}/diff`, ...(params ? [params] : [])] as const;

export type GetPackageDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPackageDiff>>
>;
export type GetPackageDiffQueryError = ErrorType<void>;

/**
 * @summary Get a diff of the changes between two versions of the package
 */
export const useGetPackageDiff = <TError = ErrorType<void>>(
  id: string,
  params: GetPackageDiffParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getPackageDiff>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPackageDiffKey(id, params) : null));
  const swrFn = () => getPackageDiff(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns a list of checks that help validate the health of an installation of the project
 * @summary Get a list of checks known for the provided project
 */
export const listProjectChecks = (
  id: string,
  params?: ListProjectChecksParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListProjectChecksResponse>(
    { url: `/projects/${id}/checks`, method: 'GET', params },
    options,
  );
};

export const getListProjectChecksKey = (
  id: string,
  params?: ListProjectChecksParams,
) => [`/projects/${id}/checks`, ...(params ? [params] : [])] as const;

export type ListProjectChecksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjectChecks>>
>;
export type ListProjectChecksQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of checks known for the provided project
 */
export const useListProjectChecks = <TError = ErrorType<unknown>>(
  id: string,
  params?: ListProjectChecksParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listProjectChecks>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListProjectChecksKey(id, params) : null));
  const swrFn = () => listProjectChecks(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns a list of known releases for the provided project
 * @summary Get a list of releases for the provided project
 */
export const listProjectReleases = (
  id: string,
  params?: ListProjectReleasesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListProjectReleasesResponse>(
    { url: `/projects/${id}/releases`, method: 'GET', params },
    options,
  );
};

export const getListProjectReleasesKey = (
  id: string,
  params?: ListProjectReleasesParams,
) => [`/projects/${id}/releases`, ...(params ? [params] : [])] as const;

export type ListProjectReleasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjectReleases>>
>;
export type ListProjectReleasesQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of releases for the provided project
 */
export const useListProjectReleases = <TError = ErrorType<unknown>>(
  id: string,
  params?: ListProjectReleasesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listProjectReleases>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListProjectReleasesKey(id, params) : null));
  const swrFn = () => listProjectReleases(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Upgrade Plans associated with a Chkk account
 */
export const listUpgradePlans = (
  params?: ListUpgradePlansParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlansResponse>(
    { url: `/upgrades`, method: 'GET', params },
    options,
  );
};

export const getListUpgradePlansKey = (params?: ListUpgradePlansParams) =>
  [`/upgrades`, ...(params ? [params] : [])] as const;

export type ListUpgradePlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlans>>
>;
export type ListUpgradePlansQueryError = ErrorType<unknown>;

export const useListUpgradePlans = <TError = ErrorType<unknown>>(
  params?: ListUpgradePlansParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlans>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradePlansKey(params) : null));
  const swrFn = () => listUpgradePlans(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create an Upgrade Plan for your resources (Clusters, Add-Ons, Applications etc)
 * @summary Create an Upgrade Plan
 */
export const createUpgradePlan = (
  createUpgradePlanRequest: BodyType<CreateUpgradePlanRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradePlan>(
    {
      url: `/upgrades`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradePlanRequest,
    },
    options,
  );
};

export const getCreateUpgradePlanMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradePlanRequest },
  ): Promise<UpgradePlan> => {
    return createUpgradePlan(arg, options);
  };
};
export const getCreateUpgradePlanMutationKey = () => `/upgrades` as const;

export type CreateUpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradePlan>>
>;
export type CreateUpgradePlanMutationError = ErrorType<unknown>;

/**
 * @summary Create an Upgrade Plan
 */
export const useCreateUpgradePlan = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createUpgradePlan>>,
    TError,
    string,
    CreateUpgradePlanRequest,
    Awaited<ReturnType<typeof createUpgradePlan>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateUpgradePlanMutationKey();
  const swrFn = getCreateUpgradePlanMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes the specified Upgrade Plan.
 * @summary Delete an Upgrade Plan
 */
export const deleteUpgradePlan = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/upgrades/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteUpgradePlanMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradePlan(id, options);
  };
};
export const getDeleteUpgradePlanMutationKey = (id: string) =>
  `/upgrades/${id}` as const;

export type DeleteUpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradePlan>>
>;
export type DeleteUpgradePlanMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Upgrade Plan
 */
export const useDeleteUpgradePlan = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradePlan>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradePlan>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteUpgradePlanMutationKey(id);
  const swrFn = getDeleteUpgradePlanMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Upgrade Plan.
 * @summary Get information about an Upgrade Plan
 */
export const getUpgradePlan = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradePlan>(
    { url: `/upgrades/${id}`, method: 'GET' },
    options,
  );
};

export const getGetUpgradePlanKey = (id: string) =>
  [`/upgrades/${id}`] as const;

export type GetUpgradePlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlan>>
>;
export type GetUpgradePlanQueryError = ErrorType<void>;

/**
 * @summary Get information about an Upgrade Plan
 */
export const useGetUpgradePlan = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlan>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetUpgradePlanKey(id) : null));
  const swrFn = () => getUpgradePlan(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Updates the base properties of an Upgrade Plan
 * @summary Update an Upgrade Plan
 */
export const updateUpgradePlan = (
  id: string,
  updateUpgradePlanRequest: BodyType<UpdateUpgradePlanRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradePlan>(
    {
      url: `/upgrades/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradePlanRequest,
    },
    options,
  );
};

export const getUpdateUpgradePlanMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradePlanRequest },
  ): Promise<UpgradePlan> => {
    return updateUpgradePlan(id, arg, options);
  };
};
export const getUpdateUpgradePlanMutationKey = (id: string) =>
  `/upgrades/${id}` as const;

export type UpdateUpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradePlan>>
>;
export type UpdateUpgradePlanMutationError = ErrorType<void>;

/**
 * @summary Update an Upgrade Plan
 */
export const useUpdateUpgradePlan = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradePlan>>,
      TError,
      string,
      UpdateUpgradePlanRequest,
      Awaited<ReturnType<typeof updateUpgradePlan>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateUpgradePlanMutationKey(id);
  const swrFn = getUpdateUpgradePlanMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns an exported version of an Upgrade Plan (e.g. a Markdown document)
 * @summary Exported version of an Upgrade Plan
 */
export const exportUpgradePlan = (
  id: string,
  params: ExportUpgradePlanParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/upgrades/${id}/export`, method: 'GET', params },
    options,
  );
};

export const getExportUpgradePlanKey = (
  id: string,
  params: ExportUpgradePlanParams,
) => [`/upgrades/${id}/export`, ...(params ? [params] : [])] as const;

export type ExportUpgradePlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportUpgradePlan>>
>;
export type ExportUpgradePlanQueryError = ErrorType<void>;

/**
 * @summary Exported version of an Upgrade Plan
 */
export const useExportUpgradePlan = <TError = ErrorType<void>>(
  id: string,
  params: ExportUpgradePlanParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof exportUpgradePlan>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getExportUpgradePlanKey(id, params) : null));
  const swrFn = () => exportUpgradePlan(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the history of the specified Upgrade Plan.
 * @summary List history entries of an Upgrade Plan
 */
export const listUpgradePlanHistory = (
  id: string,
  params?: ListUpgradePlanHistoryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanHistoryResponse>(
    { url: `/upgrades/${id}/history`, method: 'GET', params },
    options,
  );
};

export const getListUpgradePlanHistoryKey = (
  id: string,
  params?: ListUpgradePlanHistoryParams,
) => [`/upgrades/${id}/history`, ...(params ? [params] : [])] as const;

export type ListUpgradePlanHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanHistory>>
>;
export type ListUpgradePlanHistoryQueryError = ErrorType<void>;

/**
 * @summary List history entries of an Upgrade Plan
 */
export const useListUpgradePlanHistory = <TError = ErrorType<void>>(
  id: string,
  params?: ListUpgradePlanHistoryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanHistory>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradePlanHistoryKey(id, params) : null));
  const swrFn = () => listUpgradePlanHistory(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Stages for an Upgrade Plan
 */
export const listUpgradePlanStages = (
  id: string,
  params?: ListUpgradePlanStagesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanStagesResponse>(
    { url: `/upgrades/${id}/stages`, method: 'GET', params },
    options,
  );
};

export const getListUpgradePlanStagesKey = (
  id: string,
  params?: ListUpgradePlanStagesParams,
) => [`/upgrades/${id}/stages`, ...(params ? [params] : [])] as const;

export type ListUpgradePlanStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanStages>>
>;
export type ListUpgradePlanStagesQueryError = ErrorType<unknown>;

export const useListUpgradePlanStages = <TError = ErrorType<unknown>>(
  id: string,
  params?: ListUpgradePlanStagesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradePlanStagesKey(id, params) : null));
  const swrFn = () => listUpgradePlanStages(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Stage of an Upgrade Plan
 * @summary Get information about an Stage of an Upgrade Plan
 */
export const getUpgradePlanStage = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStage>(
    { url: `/upgrades/${id}/stages/${stageNumber}`, method: 'GET' },
    options,
  );
};

export const getGetUpgradePlanStageKey = (id: string, stageNumber: string) =>
  [`/upgrades/${id}/stages/${stageNumber}`] as const;

export type GetUpgradePlanStageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanStage>>
>;
export type GetUpgradePlanStageQueryError = ErrorType<void>;

/**
 * @summary Get information about an Stage of an Upgrade Plan
 */
export const useGetUpgradePlanStage = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanStage>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetUpgradePlanStageKey(id, stageNumber) : null));
  const swrFn = () => getUpgradePlanStage(id, stageNumber, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all actions performed on the stage
 * @deprecated
 */
export const listUpgradePlanStageActions = (
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageActionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanStageActionsResponse>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/actions`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradePlanStageActionsKey = (
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageActionsParams,
) =>
  [
    `/upgrades/${id}/stages/${stageNumber}/actions`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradePlanStageActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanStageActions>>
>;
export type ListUpgradePlanStageActionsQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useListUpgradePlanStageActions = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageActionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanStageActions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradePlanStageActionsKey(id, stageNumber, params)
        : null);
  const swrFn = () =>
    listUpgradePlanStageActions(id, stageNumber, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the object.
 * @deprecated
 * @summary Trigger an action on the object
 */
export const createUpgradePlanStageAction = (
  id: string,
  stageNumber: string,
  createUpgradePlanStageActionRequest: BodyType<CreateUpgradePlanStageActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStage>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradePlanStageActionRequest,
    },
    options,
  );
};

export const getCreateUpgradePlanStageActionMutationFetcher = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradePlanStageActionRequest },
  ): Promise<UpgradeStage> => {
    return createUpgradePlanStageAction(id, stageNumber, arg, options);
  };
};
export const getCreateUpgradePlanStageActionMutationKey = (
  id: string,
  stageNumber: string,
) => `/upgrades/${id}/stages/${stageNumber}/actions` as const;

export type CreateUpgradePlanStageActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradePlanStageAction>>
>;
export type CreateUpgradePlanStageActionMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Trigger an action on the object
 */
export const useCreateUpgradePlanStageAction = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradePlanStageAction>>,
      TError,
      string,
      CreateUpgradePlanStageActionRequest,
      Awaited<ReturnType<typeof createUpgradePlanStageAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradePlanStageActionMutationKey(id, stageNumber);
  const swrFn = getCreateUpgradePlanStageActionMutationFetcher(
    id,
    stageNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get information of an action
 * @deprecated
 * @summary Get information of an action
 */
export const getUpgradePlanStageAction = (
  id: string,
  stageNumber: string,
  actionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageAction>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/action/${actionId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanStageActionKey = (
  id: string,
  stageNumber: string,
  actionId: string,
) => [`/upgrades/${id}/stages/${stageNumber}/action/${actionId}`] as const;

export type GetUpgradePlanStageActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanStageAction>>
>;
export type GetUpgradePlanStageActionQueryError = ErrorType<void>;

/**
 * @deprecated
 * @summary Get information of an action
 */
export const useGetUpgradePlanStageAction = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  actionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanStageAction>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && actionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanStageActionKey(id, stageNumber, actionId)
        : null);
  const swrFn = () =>
    getUpgradePlanStageAction(id, stageNumber, actionId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Steps for an Upgrade Plan Stage
 */
export const listUpgradePlanStageSteps = (
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageStepsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanStageStepsResponse>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradePlanStageStepsKey = (
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageStepsParams,
) =>
  [
    `/upgrades/${id}/stages/${stageNumber}/steps`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradePlanStageStepsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanStageSteps>>
>;
export type ListUpgradePlanStageStepsQueryError = ErrorType<unknown>;

export const useListUpgradePlanStageSteps = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  params?: ListUpgradePlanStageStepsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanStageSteps>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradePlanStageStepsKey(id, stageNumber, params)
        : null);
  const swrFn = () =>
    listUpgradePlanStageSteps(id, stageNumber, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new Step
 * @summary Create a new Step
 */
export const createUpgradePlanStageStep = (
  id: string,
  stageNumber: string,
  createUpgradePlanStageStepRequest: BodyType<CreateUpgradePlanStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradePlanStageStepRequest,
    },
    options,
  );
};

export const getCreateUpgradePlanStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradePlanStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return createUpgradePlanStageStep(id, stageNumber, arg, options);
  };
};
export const getCreateUpgradePlanStageStepMutationKey = (
  id: string,
  stageNumber: string,
) => `/upgrades/${id}/stages/${stageNumber}/steps` as const;

export type CreateUpgradePlanStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradePlanStageStep>>
>;
export type CreateUpgradePlanStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Create a new Step
 */
export const useCreateUpgradePlanStageStep = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradePlanStageStep>>,
      TError,
      string,
      CreateUpgradePlanStageStepRequest,
      Awaited<ReturnType<typeof createUpgradePlanStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradePlanStageStepMutationKey(id, stageNumber);
  const swrFn = getCreateUpgradePlanStageStepMutationFetcher(
    id,
    stageNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete the specified Step of a Stage
 * @summary Delete an Step of a Stage
 */
export const deleteUpgradePlanStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteUpgradePlanStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradePlanStageStep(id, stageNumber, stepNumber, options);
  };
};
export const getDeleteUpgradePlanStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) => `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type DeleteUpgradePlanStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradePlanStageStep>>
>;
export type DeleteUpgradePlanStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Step of a Stage
 */
export const useDeleteUpgradePlanStageStep = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradePlanStageStep>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradePlanStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradePlanStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getDeleteUpgradePlanStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Step of a Stage
 * @summary Get information about an Step of a Stage
 */
export const getUpgradePlanStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanStageStepKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) => [`/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}`] as const;

export type GetUpgradePlanStageStepQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanStageStep>>
>;
export type GetUpgradePlanStageStepQueryError = ErrorType<void>;

/**
 * @summary Get information about an Step of a Stage
 */
export const useGetUpgradePlanStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanStageStep>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanStageStepKey(id, stageNumber, stepNumber)
        : null);
  const swrFn = () =>
    getUpgradePlanStageStep(id, stageNumber, stepNumber, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update information about the specified Step of a Stage
 * @summary Update information about an Step of a Stage
 */
export const updateUpgradePlanStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  updateUpgradePlanStageStepRequest: BodyType<UpdateUpgradePlanStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradePlanStageStepRequest,
    },
    options,
  );
};

export const getUpdateUpgradePlanStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradePlanStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return updateUpgradePlanStageStep(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getUpdateUpgradePlanStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) => `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type UpdateUpgradePlanStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradePlanStageStep>>
>;
export type UpdateUpgradePlanStageStepMutationError = ErrorType<void>;

/**
 * @summary Update information about an Step of a Stage
 */
export const useUpdateUpgradePlanStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradePlanStageStep>>,
      TError,
      string,
      UpdateUpgradePlanStageStepRequest,
      Awaited<ReturnType<typeof updateUpgradePlanStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradePlanStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getUpdateUpgradePlanStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all comments for the specified step.
 */
export const listUpgradePlanStageStepComments = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepCommentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanStageStepCommentsResponse>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradePlanStageStepCommentsKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepCommentsParams,
) =>
  [
    `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradePlanStageStepCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanStageStepComments>>
>;
export type ListUpgradePlanStageStepCommentsQueryError = ErrorType<unknown>;

export const useListUpgradePlanStageStepComments = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepCommentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanStageStepComments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradePlanStageStepCommentsKey(
            id,
            stageNumber,
            stepNumber,
            params,
          )
        : null);
  const swrFn = () =>
    listUpgradePlanStageStepComments(
      id,
      stageNumber,
      stepNumber,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Post a new comment on the specific step
 * @summary Post a comment on the specific step
 */
export const createUpgradePlanStageStepComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradePlanStageStepCommentRequest: BodyType<CreateUpgradePlanStageStepCommentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradePlanStageStepCommentRequest,
    },
    options,
  );
};

export const getCreateUpgradePlanStageStepCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradePlanStageStepCommentRequest },
  ): Promise<void> => {
    return createUpgradePlanStageStepComment(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradePlanStageStepCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments` as const;

export type CreateUpgradePlanStageStepCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradePlanStageStepComment>>
>;
export type CreateUpgradePlanStageStepCommentMutationError = ErrorType<unknown>;

/**
 * @summary Post a comment on the specific step
 */
export const useCreateUpgradePlanStageStepComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradePlanStageStepComment>>,
      TError,
      string,
      CreateUpgradePlanStageStepCommentRequest,
      Awaited<ReturnType<typeof createUpgradePlanStageStepComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradePlanStageStepCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getCreateUpgradePlanStageStepCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes Last Comment on Upgrade Plan Step
 * @summary Delete Last Comment on Step
 */
export const deleteUpgradePlanStageStepLastComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments/${threadId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteUpgradePlanStageStepLastCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradePlanStageStepLastComment(
      id,
      stageNumber,
      stepNumber,
      threadId,
      options,
    );
  };
};
export const getDeleteUpgradePlanStageStepLastCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
) =>
  `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/comments/${threadId}` as const;

export type DeleteUpgradePlanStageStepLastCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradePlanStageStepLastComment>>
>;
export type DeleteUpgradePlanStageStepLastCommentMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete Last Comment on Step
 */
export const useDeleteUpgradePlanStageStepLastComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradePlanStageStepLastComment>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradePlanStageStepLastComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradePlanStageStepLastCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
      threadId,
    );
  const swrFn = getDeleteUpgradePlanStageStepLastCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    threadId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all actions performed on the step
 * @deprecated
 */
export const listUpgradePlanStageStepActions = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepActionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanStageStepActionsResponse>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradePlanStageStepActionsKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepActionsParams,
) =>
  [
    `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradePlanStageStepActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanStageStepActions>>
>;
export type ListUpgradePlanStageStepActionsQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useListUpgradePlanStageStepActions = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradePlanStageStepActionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanStageStepActions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradePlanStageStepActionsKey(
            id,
            stageNumber,
            stepNumber,
            params,
          )
        : null);
  const swrFn = () =>
    listUpgradePlanStageStepActions(
      id,
      stageNumber,
      stepNumber,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the object.
 * @deprecated
 * @summary Trigger an action on the object
 */
export const createUpgradePlanStageStepAction = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradePlanStageStepActionRequest: BodyType<CreateUpgradePlanStageStepActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradePlanStageStepActionRequest,
    },
    options,
  );
};

export const getCreateUpgradePlanStageStepActionMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradePlanStageStepActionRequest },
  ): Promise<UpgradeStageStep> => {
    return createUpgradePlanStageStepAction(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradePlanStageStepActionMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/actions` as const;

export type CreateUpgradePlanStageStepActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradePlanStageStepAction>>
>;
export type CreateUpgradePlanStageStepActionMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Trigger an action on the object
 */
export const useCreateUpgradePlanStageStepAction = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradePlanStageStepAction>>,
      TError,
      string,
      CreateUpgradePlanStageStepActionRequest,
      Awaited<ReturnType<typeof createUpgradePlanStageStepAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradePlanStageStepActionMutationKey(id, stageNumber, stepNumber);
  const swrFn = getCreateUpgradePlanStageStepActionMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get information of an action
 * @deprecated
 * @summary Get information of an action
 */
export const getUpgradePlanStageStepAction = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStepAction>(
    {
      url: `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/action/${actionId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanStageStepActionKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
) =>
  [
    `/upgrades/${id}/stages/${stageNumber}/steps/${stepNumber}/action/${actionId}`,
  ] as const;

export type GetUpgradePlanStageStepActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanStageStepAction>>
>;
export type GetUpgradePlanStageStepActionQueryError = ErrorType<void>;

/**
 * @deprecated
 * @summary Get information of an action
 */
export const useGetUpgradePlanStageStepAction = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanStageStepAction>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    !!(id && stageNumber && stepNumber && actionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanStageStepActionKey(
            id,
            stageNumber,
            stepNumber,
            actionId,
          )
        : null);
  const swrFn = () =>
    getUpgradePlanStageStepAction(
      id,
      stageNumber,
      stepNumber,
      actionId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about suggested changes to Package Installs based on an Upgrade Plan.
 * @summary List changes to Package Installs from an Upgrade Plan
 */
export const listUpgradePlanPackageInstallChanges = (
  id: string,
  params?: ListUpgradePlanPackageInstallChangesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanPackageInstallChangesResponse>(
    { url: `/upgrades/${id}/package_install_changes`, method: 'GET', params },
    options,
  );
};

export const getListUpgradePlanPackageInstallChangesKey = (
  id: string,
  params?: ListUpgradePlanPackageInstallChangesParams,
) =>
  [
    `/upgrades/${id}/package_install_changes`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradePlanPackageInstallChangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradePlanPackageInstallChanges>>
>;
export type ListUpgradePlanPackageInstallChangesQueryError = ErrorType<void>;

/**
 * @summary List changes to Package Installs from an Upgrade Plan
 */
export const useListUpgradePlanPackageInstallChanges = <
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListUpgradePlanPackageInstallChangesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradePlanPackageInstallChanges>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradePlanPackageInstallChangesKey(id, params)
        : null);
  const swrFn = () =>
    listUpgradePlanPackageInstallChanges(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get a specific Package Install Change from an Upgrade Plan
 */
export const getUpgradePlanPackageInstallChange = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PackageInstallChange>(
    {
      url: `/upgrades/${id}/package_install_changes/${packageInstallChangeId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanPackageInstallChangeKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrades/${id}/package_install_changes/${packageInstallChangeId}`,
  ] as const;

export type GetUpgradePlanPackageInstallChangeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanPackageInstallChange>>
>;
export type GetUpgradePlanPackageInstallChangeQueryError = ErrorType<void>;

/**
 * @summary Get a specific Package Install Change from an Upgrade Plan
 */
export const useGetUpgradePlanPackageInstallChange = <TError = ErrorType<void>>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanPackageInstallChange>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanPackageInstallChangeKey(id, packageInstallChangeId)
        : null);
  const swrFn = () =>
    getUpgradePlanPackageInstallChange(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get the Notable Changes for a Package Install Change from an Upgrade Plan
 */
export const getUpgradePlanPackageInstallChangeNotableChanges = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<NotableChanges>(
    {
      url: `/upgrades/${id}/package_install_changes/${packageInstallChangeId}/notable_changes`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanPackageInstallChangeNotableChangesKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrades/${id}/package_install_changes/${packageInstallChangeId}/notable_changes`,
  ] as const;

export type GetUpgradePlanPackageInstallChangeNotableChangesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUpgradePlanPackageInstallChangeNotableChanges>>
  >;
export type GetUpgradePlanPackageInstallChangeNotableChangesQueryError =
  ErrorType<void>;

/**
 * @summary Get the Notable Changes for a Package Install Change from an Upgrade Plan
 */
export const useGetUpgradePlanPackageInstallChangeNotableChanges = <
  TError = ErrorType<void>,
>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<
        ReturnType<typeof getUpgradePlanPackageInstallChangeNotableChanges>
      >,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanPackageInstallChangeNotableChangesKey(
            id,
            packageInstallChangeId,
          )
        : null);
  const swrFn = () =>
    getUpgradePlanPackageInstallChangeNotableChanges(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get the Reasons for a Package Install Change from an Upgrade Plan
 */
export const getUpgradePlanPackageInstallChangeReasons = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradePlanPackageInstallChangeReasonsResponse>(
    {
      url: `/upgrades/${id}/package_install_changes/${packageInstallChangeId}/reasons`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradePlanPackageInstallChangeReasonsKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrades/${id}/package_install_changes/${packageInstallChangeId}/reasons`,
  ] as const;

export type GetUpgradePlanPackageInstallChangeReasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePlanPackageInstallChangeReasons>>
>;
export type GetUpgradePlanPackageInstallChangeReasonsQueryError =
  ErrorType<void>;

/**
 * @summary Get the Reasons for a Package Install Change from an Upgrade Plan
 */
export const useGetUpgradePlanPackageInstallChangeReasons = <
  TError = ErrorType<void>,
>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradePlanPackageInstallChangeReasons>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradePlanPackageInstallChangeReasonsKey(
            id,
            packageInstallChangeId,
          )
        : null);
  const swrFn = () =>
    getUpgradePlanPackageInstallChangeReasons(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Upgrade Templates associated with a Chkk account
 */
export const listUpgradeTemplates = (
  params?: ListUpgradeTemplatesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplatesResponse>(
    { url: `/upgrade_templates`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeTemplatesKey = (
  params?: ListUpgradeTemplatesParams,
) => [`/upgrade_templates`, ...(params ? [params] : [])] as const;

export type ListUpgradeTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplates>>
>;
export type ListUpgradeTemplatesQueryError = ErrorType<unknown>;

export const useListUpgradeTemplates = <TError = ErrorType<unknown>>(
  params?: ListUpgradeTemplatesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplates>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeTemplatesKey(params) : null));
  const swrFn = () => listUpgradeTemplates(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create an Upgrade Template for your resources (Clusters, Add-Ons, Applications etc)
 * @summary Create an Upgrade Template
 */
export const createUpgradeTemplate = (
  createUpgradeTemplateRequest: BodyType<CreateUpgradeTemplateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeTemplate>(
    {
      url: `/upgrade_templates`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeTemplateRequest,
    },
    options,
  );
};

export const getCreateUpgradeTemplateMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeTemplateRequest },
  ): Promise<UpgradeTemplate> => {
    return createUpgradeTemplate(arg, options);
  };
};
export const getCreateUpgradeTemplateMutationKey = () =>
  `/upgrade_templates` as const;

export type CreateUpgradeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplate>>
>;
export type CreateUpgradeTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Create an Upgrade Template
 */
export const useCreateUpgradeTemplate = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createUpgradeTemplate>>,
    TError,
    string,
    CreateUpgradeTemplateRequest,
    Awaited<ReturnType<typeof createUpgradeTemplate>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateUpgradeTemplateMutationKey();
  const swrFn = getCreateUpgradeTemplateMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes the specified Upgrade Template.
 * @summary Delete an Upgrade Template
 */
export const deleteUpgradeTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/upgrade_templates/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteUpgradeTemplateMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradeTemplate(id, options);
  };
};
export const getDeleteUpgradeTemplateMutationKey = (id: string) =>
  `/upgrade_templates/${id}` as const;

export type DeleteUpgradeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradeTemplate>>
>;
export type DeleteUpgradeTemplateMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Upgrade Template
 */
export const useDeleteUpgradeTemplate = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeTemplate>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradeTemplate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteUpgradeTemplateMutationKey(id);
  const swrFn = getDeleteUpgradeTemplateMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Upgrade Template.
 * @summary Get information about an Upgrade Template
 */
export const getUpgradeTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeTemplate>(
    { url: `/upgrade_templates/${id}`, method: 'GET' },
    options,
  );
};

export const getGetUpgradeTemplateKey = (id: string) =>
  [`/upgrade_templates/${id}`] as const;

export type GetUpgradeTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplate>>
>;
export type GetUpgradeTemplateQueryError = ErrorType<void>;

/**
 * @summary Get information about an Upgrade Template
 */
export const useGetUpgradeTemplate = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplate>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetUpgradeTemplateKey(id) : null));
  const swrFn = () => getUpgradeTemplate(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Updates the base properties of an Upgrade Template
 * @summary Update an Upgrade Template
 */
export const updateUpgradeTemplate = (
  id: string,
  updateUpgradeTemplateRequest: BodyType<UpdateUpgradeTemplateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeTemplate>(
    {
      url: `/upgrade_templates/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradeTemplateRequest,
    },
    options,
  );
};

export const getUpdateUpgradeTemplateMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradeTemplateRequest },
  ): Promise<UpgradeTemplate> => {
    return updateUpgradeTemplate(id, arg, options);
  };
};
export const getUpdateUpgradeTemplateMutationKey = (id: string) =>
  `/upgrade_templates/${id}` as const;

export type UpdateUpgradeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplate>>
>;
export type UpdateUpgradeTemplateMutationError = ErrorType<void>;

/**
 * @summary Update an Upgrade Template
 */
export const useUpdateUpgradeTemplate = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplate>>,
      TError,
      string,
      UpdateUpgradeTemplateRequest,
      Awaited<ReturnType<typeof updateUpgradeTemplate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateUpgradeTemplateMutationKey(id);
  const swrFn = getUpdateUpgradeTemplateMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns an exported version of an Upgrade Template (e.g. a Markdown document)
 * @summary Exported version of an Upgrade Template
 */
export const exportUpgradeTemplate = (
  id: string,
  params: ExportUpgradeTemplateParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/upgrade_templates/${id}/export`, method: 'GET', params },
    options,
  );
};

export const getExportUpgradeTemplateKey = (
  id: string,
  params: ExportUpgradeTemplateParams,
) => [`/upgrade_templates/${id}/export`, ...(params ? [params] : [])] as const;

export type ExportUpgradeTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportUpgradeTemplate>>
>;
export type ExportUpgradeTemplateQueryError = ErrorType<void>;

/**
 * @summary Exported version of an Upgrade Template
 */
export const useExportUpgradeTemplate = <TError = ErrorType<void>>(
  id: string,
  params: ExportUpgradeTemplateParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof exportUpgradeTemplate>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getExportUpgradeTemplateKey(id, params) : null));
  const swrFn = () => exportUpgradeTemplate(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Generate a presigned URL for a package snapshot.
 */
export const getUpgradeTemplateProjectPackageSnapshot = (
  templateId: string,
  packageId: string,
  params: GetUpgradeTemplateProjectPackageSnapshotParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CrdsPresignResponse>(
    {
      url: `/contexts/upgrade_templates/${templateId}/packages/${packageId}/snapshots`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getGetUpgradeTemplateProjectPackageSnapshotKey = (
  templateId: string,
  packageId: string,
  params: GetUpgradeTemplateProjectPackageSnapshotParams,
) =>
  [
    `/contexts/upgrade_templates/${templateId}/packages/${packageId}/snapshots`,
    ...(params ? [params] : []),
  ] as const;

export type GetUpgradeTemplateProjectPackageSnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateProjectPackageSnapshot>>
>;
export type GetUpgradeTemplateProjectPackageSnapshotQueryError =
  ErrorType<void>;

export const useGetUpgradeTemplateProjectPackageSnapshot = <
  TError = ErrorType<void>,
>(
  templateId: string,
  packageId: string,
  params: GetUpgradeTemplateProjectPackageSnapshotParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateProjectPackageSnapshot>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(templateId && packageId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateProjectPackageSnapshotKey(
            templateId,
            packageId,
            params,
          )
        : null);
  const swrFn = () =>
    getUpgradeTemplateProjectPackageSnapshot(
      templateId,
      packageId,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List Package Upgrade Contexts for the account.

When `upgrade_template_id`, `upgrade_plan_id`, or `upgrade_assessment_id` is provided, this returns only the latest Package Upgrade Context for that source.
When not provided, this returns all Package Upgrade Contexts. Pagination parameters are supported but ignored when filtering for the latest.

 * @summary List Package Upgrade Contexts
 */
export const listPackageUpgradeContexts = (
  params?: ListPackageUpgradeContextsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListPackageUpgradeContextsResponse>(
    { url: `/contexts/package_upgrades`, method: 'GET', params },
    options,
  );
};

export const getListPackageUpgradeContextsKey = (
  params?: ListPackageUpgradeContextsParams,
) => [`/contexts/package_upgrades`, ...(params ? [params] : [])] as const;

export type ListPackageUpgradeContextsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPackageUpgradeContexts>>
>;
export type ListPackageUpgradeContextsQueryError = ErrorType<unknown>;

/**
 * @summary List Package Upgrade Contexts
 */
export const useListPackageUpgradeContexts = <TError = ErrorType<unknown>>(
  params?: ListPackageUpgradeContextsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listPackageUpgradeContexts>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListPackageUpgradeContextsKey(params) : null));
  const swrFn = () => listPackageUpgradeContexts(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new Package Upgrade Context from either an Upgrade Plan package change or an Upgrade Assessment package recommendation.

Provide `package_install_change_id` and exactly one of `upgrade_plan_id` or `upgrade_assessment_id`.

Set `disable_telemetry=true` in the request body to opt this context out of finalized report uploads.

 * @summary Create a Package Upgrade Context
 */
export const createPackageUpgradeContext = (
  createPackageUpgradeContextRequest: BodyType<CreatePackageUpgradeContextRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CreatePackageUpgradeContextResponse>(
    {
      url: `/contexts/package_upgrades`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPackageUpgradeContextRequest,
    },
    options,
  );
};

export const getCreatePackageUpgradeContextMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreatePackageUpgradeContextRequest },
  ): Promise<CreatePackageUpgradeContextResponse> => {
    return createPackageUpgradeContext(arg, options);
  };
};
export const getCreatePackageUpgradeContextMutationKey = () =>
  `/contexts/package_upgrades` as const;

export type CreatePackageUpgradeContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPackageUpgradeContext>>
>;
export type CreatePackageUpgradeContextMutationError = ErrorType<unknown>;

/**
 * @summary Create a Package Upgrade Context
 */
export const useCreatePackageUpgradeContext = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createPackageUpgradeContext>>,
    TError,
    string,
    CreatePackageUpgradeContextRequest,
    Awaited<ReturnType<typeof createPackageUpgradeContext>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreatePackageUpgradeContextMutationKey();
  const swrFn = getCreatePackageUpgradeContextMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve a Package Upgrade Context by `package_upgrade_context_id`.

If the Upgrade Context is in status `ready`, this endpoint returns a presigned URL payload for the context snapshot`.
The response also exposes whether telemetry uploads are enabled and the exact telemetry upload endpoint for finalized reports.

 * @summary Get a Package Upgrade Context
 */
export const getPackageUpgradeContext = (
  packageUpgradeContextId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PackageUpgradeContext>(
    {
      url: `/contexts/package_upgrades/${packageUpgradeContextId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetPackageUpgradeContextKey = (
  packageUpgradeContextId: string,
) => [`/contexts/package_upgrades/${packageUpgradeContextId}`] as const;

export type GetPackageUpgradeContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPackageUpgradeContext>>
>;
export type GetPackageUpgradeContextQueryError = ErrorType<void>;

/**
 * @summary Get a Package Upgrade Context
 */
export const useGetPackageUpgradeContext = <TError = ErrorType<void>>(
  packageUpgradeContextId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getPackageUpgradeContext>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!packageUpgradeContextId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetPackageUpgradeContextKey(packageUpgradeContextId)
        : null);
  const swrFn = () =>
    getPackageUpgradeContext(packageUpgradeContextId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Upload the locally generated snapshot tarball and finalize the Package Upgrade Context.

This endpoint is used by local generation flows to publish the completed snapshot and mark the context ready.

 * @summary Finalize a Package Upgrade Context
 */
export const finalizePackageUpgradeContextLocal = (
  packageUpgradeContextId: string,
  finalizePackageUpgradeContextRequest: BodyType<FinalizePackageUpgradeContextRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PackageUpgradeContext>(
    {
      url: `/contexts/package_upgrades/${packageUpgradeContextId}/finalize`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: finalizePackageUpgradeContextRequest,
    },
    options,
  );
};

export const getFinalizePackageUpgradeContextLocalMutationFetcher = (
  packageUpgradeContextId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: FinalizePackageUpgradeContextRequest },
  ): Promise<PackageUpgradeContext> => {
    return finalizePackageUpgradeContextLocal(
      packageUpgradeContextId,
      arg,
      options,
    );
  };
};
export const getFinalizePackageUpgradeContextLocalMutationKey = (
  packageUpgradeContextId: string,
) => `/contexts/package_upgrades/${packageUpgradeContextId}/finalize` as const;

export type FinalizePackageUpgradeContextLocalMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizePackageUpgradeContextLocal>>
>;
export type FinalizePackageUpgradeContextLocalMutationError = ErrorType<void>;

/**
 * @summary Finalize a Package Upgrade Context
 */
export const useFinalizePackageUpgradeContextLocal = <TError = ErrorType<void>>(
  packageUpgradeContextId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof finalizePackageUpgradeContextLocal>>,
      TError,
      string,
      FinalizePackageUpgradeContextRequest,
      Awaited<ReturnType<typeof finalizePackageUpgradeContextLocal>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getFinalizePackageUpgradeContextLocalMutationKey(packageUpgradeContextId);
  const swrFn = getFinalizePackageUpgradeContextLocalMutationFetcher(
    packageUpgradeContextId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Upload the finalized markdown or text report for a Package Upgrade Context.

If telemetry was disabled when the context was created, this endpoint rejects the upload.

 * @summary Upload Package Upgrade Context Telemetry
 */
export const uploadPackageUpgradeContextTelemetry = (
  packageUpgradeContextId: string,
  uploadPackageUpgradeContextTelemetryRequest: BodyType<UploadPackageUpgradeContextTelemetryRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UploadPackageUpgradeContextTelemetryResponse>(
    {
      url: `/contexts/package_upgrades/${packageUpgradeContextId}/telemetry`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadPackageUpgradeContextTelemetryRequest,
    },
    options,
  );
};

export const getUploadPackageUpgradeContextTelemetryMutationFetcher = (
  packageUpgradeContextId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UploadPackageUpgradeContextTelemetryRequest },
  ): Promise<UploadPackageUpgradeContextTelemetryResponse> => {
    return uploadPackageUpgradeContextTelemetry(
      packageUpgradeContextId,
      arg,
      options,
    );
  };
};
export const getUploadPackageUpgradeContextTelemetryMutationKey = (
  packageUpgradeContextId: string,
) => `/contexts/package_upgrades/${packageUpgradeContextId}/telemetry` as const;

export type UploadPackageUpgradeContextTelemetryMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPackageUpgradeContextTelemetry>>
>;
export type UploadPackageUpgradeContextTelemetryMutationError = ErrorType<void>;

/**
 * @summary Upload Package Upgrade Context Telemetry
 */
export const useUploadPackageUpgradeContextTelemetry = <
  TError = ErrorType<void>,
>(
  packageUpgradeContextId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof uploadPackageUpgradeContextTelemetry>>,
      TError,
      string,
      UploadPackageUpgradeContextTelemetryRequest,
      Awaited<ReturnType<typeof uploadPackageUpgradeContextTelemetry>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUploadPackageUpgradeContextTelemetryMutationKey(packageUpgradeContextId);
  const swrFn = getUploadPackageUpgradeContextTelemetryMutationFetcher(
    packageUpgradeContextId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the history of the specified Upgrade Template.
 * @summary List history entries of an Upgrade Template
 */
export const listUpgradeTemplateHistory = (
  id: string,
  params?: ListUpgradeTemplateHistoryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateHistoryResponse>(
    { url: `/upgrade_templates/${id}/history`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeTemplateHistoryKey = (
  id: string,
  params?: ListUpgradeTemplateHistoryParams,
) => [`/upgrade_templates/${id}/history`, ...(params ? [params] : [])] as const;

export type ListUpgradeTemplateHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateHistory>>
>;
export type ListUpgradeTemplateHistoryQueryError = ErrorType<void>;

/**
 * @summary List history entries of an Upgrade Template
 */
export const useListUpgradeTemplateHistory = <TError = ErrorType<void>>(
  id: string,
  params?: ListUpgradeTemplateHistoryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateHistory>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeTemplateHistoryKey(id, params) : null));
  const swrFn = () => listUpgradeTemplateHistory(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Stages for an Upgrade Template
 */
export const listUpgradeTemplateStages = (
  id: string,
  params?: ListUpgradeTemplateStagesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateStagesResponse>(
    { url: `/upgrade_templates/${id}/stages`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeTemplateStagesKey = (
  id: string,
  params?: ListUpgradeTemplateStagesParams,
) => [`/upgrade_templates/${id}/stages`, ...(params ? [params] : [])] as const;

export type ListUpgradeTemplateStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStages>>
>;
export type ListUpgradeTemplateStagesQueryError = ErrorType<unknown>;

export const useListUpgradeTemplateStages = <TError = ErrorType<unknown>>(
  id: string,
  params?: ListUpgradeTemplateStagesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeTemplateStagesKey(id, params) : null));
  const swrFn = () => listUpgradeTemplateStages(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Stage of an Upgrade Template
 * @summary Get information about an Stage of an Upgrade Template
 */
export const getUpgradeTemplateStage = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStage>(
    { url: `/upgrade_templates/${id}/stages/${stageNumber}`, method: 'GET' },
    options,
  );
};

export const getGetUpgradeTemplateStageKey = (
  id: string,
  stageNumber: string,
) => [`/upgrade_templates/${id}/stages/${stageNumber}`] as const;

export type GetUpgradeTemplateStageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateStage>>
>;
export type GetUpgradeTemplateStageQueryError = ErrorType<void>;

/**
 * @summary Get information about an Stage of an Upgrade Template
 */
export const useGetUpgradeTemplateStage = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateStage>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetUpgradeTemplateStageKey(id, stageNumber) : null));
  const swrFn = () => getUpgradeTemplateStage(id, stageNumber, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all actions performed on the stage
 * @deprecated
 */
export const listUpgradeTemplateStageActions = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageActionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateStageActionsResponse>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/actions`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeTemplateStageActionsKey = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageActionsParams,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/actions`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeTemplateStageActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStageActions>>
>;
export type ListUpgradeTemplateStageActionsQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useListUpgradeTemplateStageActions = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageActionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStageActions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeTemplateStageActionsKey(id, stageNumber, params)
        : null);
  const swrFn = () =>
    listUpgradeTemplateStageActions(id, stageNumber, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the object.
 * @deprecated
 * @summary Trigger an action on the object
 */
export const createUpgradeTemplateStageAction = (
  id: string,
  stageNumber: string,
  createUpgradeTemplateStageActionRequest: BodyType<CreateUpgradeTemplateStageActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStage>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeTemplateStageActionRequest,
    },
    options,
  );
};

export const getCreateUpgradeTemplateStageActionMutationFetcher = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeTemplateStageActionRequest },
  ): Promise<UpgradeStage> => {
    return createUpgradeTemplateStageAction(id, stageNumber, arg, options);
  };
};
export const getCreateUpgradeTemplateStageActionMutationKey = (
  id: string,
  stageNumber: string,
) => `/upgrade_templates/${id}/stages/${stageNumber}/actions` as const;

export type CreateUpgradeTemplateStageActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplateStageAction>>
>;
export type CreateUpgradeTemplateStageActionMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Trigger an action on the object
 */
export const useCreateUpgradeTemplateStageAction = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeTemplateStageAction>>,
      TError,
      string,
      CreateUpgradeTemplateStageActionRequest,
      Awaited<ReturnType<typeof createUpgradeTemplateStageAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeTemplateStageActionMutationKey(id, stageNumber);
  const swrFn = getCreateUpgradeTemplateStageActionMutationFetcher(
    id,
    stageNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get information of an action
 * @deprecated
 * @summary Get information of an action
 */
export const getUpgradeTemplateStageAction = (
  id: string,
  stageNumber: string,
  actionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageAction>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/action/${actionId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeTemplateStageActionKey = (
  id: string,
  stageNumber: string,
  actionId: string,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/action/${actionId}`,
  ] as const;

export type GetUpgradeTemplateStageActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateStageAction>>
>;
export type GetUpgradeTemplateStageActionQueryError = ErrorType<void>;

/**
 * @deprecated
 * @summary Get information of an action
 */
export const useGetUpgradeTemplateStageAction = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  actionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateStageAction>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && actionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateStageActionKey(id, stageNumber, actionId)
        : null);
  const swrFn = () =>
    getUpgradeTemplateStageAction(id, stageNumber, actionId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Steps for an Upgrade Template Stage
 */
export const listUpgradeTemplateStageSteps = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageStepsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateStageStepsResponse>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeTemplateStageStepsKey = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageStepsParams,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/steps`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeTemplateStageStepsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStageSteps>>
>;
export type ListUpgradeTemplateStageStepsQueryError = ErrorType<unknown>;

export const useListUpgradeTemplateStageSteps = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  params?: ListUpgradeTemplateStageStepsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStageSteps>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeTemplateStageStepsKey(id, stageNumber, params)
        : null);
  const swrFn = () =>
    listUpgradeTemplateStageSteps(id, stageNumber, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new Step
 * @summary Create a new Step
 */
export const createUpgradeTemplateStageStep = (
  id: string,
  stageNumber: string,
  createUpgradeTemplateStageStepRequest: BodyType<CreateUpgradeTemplateStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeTemplateStageStepRequest,
    },
    options,
  );
};

export const getCreateUpgradeTemplateStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeTemplateStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return createUpgradeTemplateStageStep(id, stageNumber, arg, options);
  };
};
export const getCreateUpgradeTemplateStageStepMutationKey = (
  id: string,
  stageNumber: string,
) => `/upgrade_templates/${id}/stages/${stageNumber}/steps` as const;

export type CreateUpgradeTemplateStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplateStageStep>>
>;
export type CreateUpgradeTemplateStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Create a new Step
 */
export const useCreateUpgradeTemplateStageStep = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeTemplateStageStep>>,
      TError,
      string,
      CreateUpgradeTemplateStageStepRequest,
      Awaited<ReturnType<typeof createUpgradeTemplateStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeTemplateStageStepMutationKey(id, stageNumber);
  const swrFn = getCreateUpgradeTemplateStageStepMutationFetcher(
    id,
    stageNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete the specified Step of a Stage
 * @summary Delete an Step of a Stage
 */
export const deleteUpgradeTemplateStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteUpgradeTemplateStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradeTemplateStageStep(id, stageNumber, stepNumber, options);
  };
};
export const getDeleteUpgradeTemplateStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type DeleteUpgradeTemplateStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradeTemplateStageStep>>
>;
export type DeleteUpgradeTemplateStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Step of a Stage
 */
export const useDeleteUpgradeTemplateStageStep = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeTemplateStageStep>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradeTemplateStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradeTemplateStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getDeleteUpgradeTemplateStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Step of a Stage
 * @summary Get information about an Step of a Stage
 */
export const getUpgradeTemplateStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeTemplateStageStepKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}`,
  ] as const;

export type GetUpgradeTemplateStageStepQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateStageStep>>
>;
export type GetUpgradeTemplateStageStepQueryError = ErrorType<void>;

/**
 * @summary Get information about an Step of a Stage
 */
export const useGetUpgradeTemplateStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateStageStep>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateStageStepKey(id, stageNumber, stepNumber)
        : null);
  const swrFn = () =>
    getUpgradeTemplateStageStep(id, stageNumber, stepNumber, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update information about the specified Step of a Stage
 * @summary Update information about an Step of a Stage
 */
export const updateUpgradeTemplateStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  updateUpgradeTemplateStageStepRequest: BodyType<UpdateUpgradeTemplateStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradeTemplateStageStepRequest,
    },
    options,
  );
};

export const getUpdateUpgradeTemplateStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradeTemplateStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return updateUpgradeTemplateStageStep(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getUpdateUpgradeTemplateStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type UpdateUpgradeTemplateStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeTemplateStageStep>>
>;
export type UpdateUpgradeTemplateStageStepMutationError = ErrorType<void>;

/**
 * @summary Update information about an Step of a Stage
 */
export const useUpdateUpgradeTemplateStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeTemplateStageStep>>,
      TError,
      string,
      UpdateUpgradeTemplateStageStepRequest,
      Awaited<ReturnType<typeof updateUpgradeTemplateStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeTemplateStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getUpdateUpgradeTemplateStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all comments for the specified step.
 */
export const listUpgradeTemplateStageStepComments = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepCommentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateStageStepCommentsResponse>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeTemplateStageStepCommentsKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepCommentsParams,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeTemplateStageStepCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStageStepComments>>
>;
export type ListUpgradeTemplateStageStepCommentsQueryError = ErrorType<unknown>;

export const useListUpgradeTemplateStageStepComments = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepCommentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStageStepComments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeTemplateStageStepCommentsKey(
            id,
            stageNumber,
            stepNumber,
            params,
          )
        : null);
  const swrFn = () =>
    listUpgradeTemplateStageStepComments(
      id,
      stageNumber,
      stepNumber,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Post a new comment on the specific step
 * @summary Post a comment on the specific step
 */
export const createUpgradeTemplateStageStepComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradeTemplateStageStepCommentRequest: BodyType<CreateUpgradeTemplateStageStepCommentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeTemplateStageStepCommentRequest,
    },
    options,
  );
};

export const getCreateUpgradeTemplateStageStepCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeTemplateStageStepCommentRequest },
  ): Promise<void> => {
    return createUpgradeTemplateStageStepComment(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradeTemplateStageStepCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments` as const;

export type CreateUpgradeTemplateStageStepCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplateStageStepComment>>
>;
export type CreateUpgradeTemplateStageStepCommentMutationError =
  ErrorType<unknown>;

/**
 * @summary Post a comment on the specific step
 */
export const useCreateUpgradeTemplateStageStepComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeTemplateStageStepComment>>,
      TError,
      string,
      CreateUpgradeTemplateStageStepCommentRequest,
      Awaited<ReturnType<typeof createUpgradeTemplateStageStepComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeTemplateStageStepCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getCreateUpgradeTemplateStageStepCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes Last Comment on Upgrade Template Step
 * @summary Delete Last Comment on Step
 */
export const deleteUpgradeTemplateStageStepLastComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  deleteUpgradeTemplateStageStepCommentRequest: BodyType<DeleteUpgradeTemplateStageStepCommentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments/${threadId}`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteUpgradeTemplateStageStepCommentRequest,
    },
    options,
  );
};

export const getDeleteUpgradeTemplateStageStepLastCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: DeleteUpgradeTemplateStageStepCommentRequest },
  ): Promise<void> => {
    return deleteUpgradeTemplateStageStepLastComment(
      id,
      stageNumber,
      stepNumber,
      threadId,
      arg,
      options,
    );
  };
};
export const getDeleteUpgradeTemplateStageStepLastCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
) =>
  `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/comments/${threadId}` as const;

export type DeleteUpgradeTemplateStageStepLastCommentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteUpgradeTemplateStageStepLastComment>>
  >;
export type DeleteUpgradeTemplateStageStepLastCommentMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete Last Comment on Step
 */
export const useDeleteUpgradeTemplateStageStepLastComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  threadId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeTemplateStageStepLastComment>>,
      TError,
      string,
      DeleteUpgradeTemplateStageStepCommentRequest,
      Awaited<ReturnType<typeof deleteUpgradeTemplateStageStepLastComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradeTemplateStageStepLastCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
      threadId,
    );
  const swrFn = getDeleteUpgradeTemplateStageStepLastCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    threadId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all actions performed on the step
 * @deprecated
 */
export const listUpgradeTemplateStageStepActions = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepActionsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeTemplateStageStepActionsResponse>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeTemplateStageStepActionsKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepActionsParams,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeTemplateStageStepActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeTemplateStageStepActions>>
>;
export type ListUpgradeTemplateStageStepActionsQueryError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useListUpgradeTemplateStageStepActions = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeTemplateStageStepActionsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeTemplateStageStepActions>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeTemplateStageStepActionsKey(
            id,
            stageNumber,
            stepNumber,
            params,
          )
        : null);
  const swrFn = () =>
    listUpgradeTemplateStageStepActions(
      id,
      stageNumber,
      stepNumber,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the object.
 * @deprecated
 * @summary Trigger an action on the object
 */
export const createUpgradeTemplateStageStepAction = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradeTemplateStageStepActionRequest: BodyType<CreateUpgradeTemplateStageStepActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeTemplateStageStepActionRequest,
    },
    options,
  );
};

export const getCreateUpgradeTemplateStageStepActionMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeTemplateStageStepActionRequest },
  ): Promise<UpgradeStageStep> => {
    return createUpgradeTemplateStageStepAction(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradeTemplateStageStepActionMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/actions` as const;

export type CreateUpgradeTemplateStageStepActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeTemplateStageStepAction>>
>;
export type CreateUpgradeTemplateStageStepActionMutationError =
  ErrorType<unknown>;

/**
 * @deprecated
 * @summary Trigger an action on the object
 */
export const useCreateUpgradeTemplateStageStepAction = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeTemplateStageStepAction>>,
      TError,
      string,
      CreateUpgradeTemplateStageStepActionRequest,
      Awaited<ReturnType<typeof createUpgradeTemplateStageStepAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeTemplateStageStepActionMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getCreateUpgradeTemplateStageStepActionMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get information of an action
 * @deprecated
 * @summary Get information of an action
 */
export const getUpgradeTemplateStageStepAction = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStepAction>(
    {
      url: `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/action/${actionId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeTemplateStageStepActionKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
) =>
  [
    `/upgrade_templates/${id}/stages/${stageNumber}/steps/${stepNumber}/action/${actionId}`,
  ] as const;

export type GetUpgradeTemplateStageStepActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeTemplateStageStepAction>>
>;
export type GetUpgradeTemplateStageStepActionQueryError = ErrorType<void>;

/**
 * @deprecated
 * @summary Get information of an action
 */
export const useGetUpgradeTemplateStageStepAction = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  actionId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeTemplateStageStepAction>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    !!(id && stageNumber && stepNumber && actionId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeTemplateStageStepActionKey(
            id,
            stageNumber,
            stepNumber,
            actionId,
          )
        : null);
  const swrFn = () =>
    getUpgradeTemplateStageStepAction(
      id,
      stageNumber,
      stepNumber,
      actionId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all Upgrade Assessments associated with a Chkk account
 */
export const listUpgradeAssessments = (
  params?: ListUpgradeAssessmentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentsResponse>(
    { url: `/upgrade_assessments`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeAssessmentsKey = (
  params?: ListUpgradeAssessmentsParams,
) => [`/upgrade_assessments`, ...(params ? [params] : [])] as const;

export type ListUpgradeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessments>>
>;
export type ListUpgradeAssessmentsQueryError = ErrorType<unknown>;

export const useListUpgradeAssessments = <TError = ErrorType<unknown>>(
  params?: ListUpgradeAssessmentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeAssessmentsKey(params) : null));
  const swrFn = () => listUpgradeAssessments(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create an Upgrade Assessment for your resources (Clusters, Add-Ons, Applications etc)
 * @summary Create an Upgrade Assessment
 */
export const createUpgradeAssessment = (
  createUpgradeAssessmentRequest: BodyType<CreateUpgradeAssessmentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeAssessment>(
    {
      url: `/upgrade_assessments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeAssessmentRequest,
    },
    options,
  );
};

export const getCreateUpgradeAssessmentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeAssessmentRequest },
  ): Promise<UpgradeAssessment> => {
    return createUpgradeAssessment(arg, options);
  };
};
export const getCreateUpgradeAssessmentMutationKey = () =>
  `/upgrade_assessments` as const;

export type CreateUpgradeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeAssessment>>
>;
export type CreateUpgradeAssessmentMutationError = ErrorType<unknown>;

/**
 * @summary Create an Upgrade Assessment
 */
export const useCreateUpgradeAssessment = <
  TError = ErrorType<unknown>,
>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createUpgradeAssessment>>,
    TError,
    string,
    CreateUpgradeAssessmentRequest,
    Awaited<ReturnType<typeof createUpgradeAssessment>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateUpgradeAssessmentMutationKey();
  const swrFn = getCreateUpgradeAssessmentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes the specified Upgrade Assessment.
 * @summary Delete an Upgrade Assessment
 */
export const deleteUpgradeAssessment = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/upgrade_assessments/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteUpgradeAssessmentMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradeAssessment(id, options);
  };
};
export const getDeleteUpgradeAssessmentMutationKey = (id: string) =>
  `/upgrade_assessments/${id}` as const;

export type DeleteUpgradeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradeAssessment>>
>;
export type DeleteUpgradeAssessmentMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Upgrade Assessment
 */
export const useDeleteUpgradeAssessment = <TError = ErrorType<unknown>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeAssessment>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradeAssessment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getDeleteUpgradeAssessmentMutationKey(id);
  const swrFn = getDeleteUpgradeAssessmentMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Upgrade Assessment.
 * @summary Get information about an Upgrade Assessment
 */
export const getUpgradeAssessment = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeAssessment>(
    { url: `/upgrade_assessments/${id}`, method: 'GET' },
    options,
  );
};

export const getGetUpgradeAssessmentKey = (id: string) =>
  [`/upgrade_assessments/${id}`] as const;

export type GetUpgradeAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeAssessment>>
>;
export type GetUpgradeAssessmentQueryError = ErrorType<void>;

/**
 * @summary Get information about an Upgrade Assessment
 */
export const useGetUpgradeAssessment = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeAssessment>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetUpgradeAssessmentKey(id) : null));
  const swrFn = () => getUpgradeAssessment(id, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Updates the base properties of an Upgrade Assessment
 * @summary Update an Upgrade Assessment
 */
export const updateUpgradeAssessment = (
  id: string,
  updateUpgradeAssessmentRequest: BodyType<UpdateUpgradeAssessmentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeAssessment>(
    {
      url: `/upgrade_assessments/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradeAssessmentRequest,
    },
    options,
  );
};

export const getUpdateUpgradeAssessmentMutationFetcher = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradeAssessmentRequest },
  ): Promise<UpgradeAssessment> => {
    return updateUpgradeAssessment(id, arg, options);
  };
};
export const getUpdateUpgradeAssessmentMutationKey = (id: string) =>
  `/upgrade_assessments/${id}` as const;

export type UpdateUpgradeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeAssessment>>
>;
export type UpdateUpgradeAssessmentMutationError = ErrorType<void>;

/**
 * @summary Update an Upgrade Assessment
 */
export const useUpdateUpgradeAssessment = <TError = ErrorType<void>>(
  id: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeAssessment>>,
      TError,
      string,
      UpdateUpgradeAssessmentRequest,
      Awaited<ReturnType<typeof updateUpgradeAssessment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getUpdateUpgradeAssessmentMutationKey(id);
  const swrFn = getUpdateUpgradeAssessmentMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns an exported version of an Upgrade Assessment (e.g. a Markdown document)
 * @summary Exported version of an Upgrade Assessment
 */
export const exportUpgradeAssessment = (
  id: string,
  params: ExportUpgradeAssessmentParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    { url: `/upgrade_assessments/${id}/export`, method: 'GET', params },
    options,
  );
};

export const getExportUpgradeAssessmentKey = (
  id: string,
  params: ExportUpgradeAssessmentParams,
) =>
  [`/upgrade_assessments/${id}/export`, ...(params ? [params] : [])] as const;

export type ExportUpgradeAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportUpgradeAssessment>>
>;
export type ExportUpgradeAssessmentQueryError = ErrorType<void>;

/**
 * @summary Exported version of an Upgrade Assessment
 */
export const useExportUpgradeAssessment = <TError = ErrorType<void>>(
  id: string,
  params: ExportUpgradeAssessmentParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof exportUpgradeAssessment>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getExportUpgradeAssessmentKey(id, params) : null));
  const swrFn = () => exportUpgradeAssessment(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the history of the specified Upgrade Assessment.
 * @summary List history entries of an Upgrade Assessment
 */
export const listUpgradeAssessmentHistory = (
  id: string,
  params?: ListUpgradeAssessmentHistoryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentHistoryResponse>(
    { url: `/upgrade_assessments/${id}/history`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeAssessmentHistoryKey = (
  id: string,
  params?: ListUpgradeAssessmentHistoryParams,
) =>
  [`/upgrade_assessments/${id}/history`, ...(params ? [params] : [])] as const;

export type ListUpgradeAssessmentHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentHistory>>
>;
export type ListUpgradeAssessmentHistoryQueryError = ErrorType<void>;

/**
 * @summary List history entries of an Upgrade Assessment
 */
export const useListUpgradeAssessmentHistory = <TError = ErrorType<void>>(
  id: string,
  params?: ListUpgradeAssessmentHistoryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentHistory>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeAssessmentHistoryKey(id, params) : null));
  const swrFn = () => listUpgradeAssessmentHistory(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Stages for an Upgrade Assessment
 */
export const listUpgradeAssessmentStages = (
  id: string,
  params?: ListUpgradeAssessmentStagesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentStagesResponse>(
    { url: `/upgrade_assessments/${id}/stages`, method: 'GET', params },
    options,
  );
};

export const getListUpgradeAssessmentStagesKey = (
  id: string,
  params?: ListUpgradeAssessmentStagesParams,
) =>
  [`/upgrade_assessments/${id}/stages`, ...(params ? [params] : [])] as const;

export type ListUpgradeAssessmentStagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentStages>>
>;
export type ListUpgradeAssessmentStagesQueryError = ErrorType<unknown>;

export const useListUpgradeAssessmentStages = <TError = ErrorType<unknown>>(
  id: string,
  params?: ListUpgradeAssessmentStagesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentStages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListUpgradeAssessmentStagesKey(id, params) : null));
  const swrFn = () => listUpgradeAssessmentStages(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the Steps for an Upgrade Assessment Stage
 */
export const listUpgradeAssessmentStageSteps = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeAssessmentStageStepsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentStageStepsResponse>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeAssessmentStageStepsKey = (
  id: string,
  stageNumber: string,
  params?: ListUpgradeAssessmentStageStepsParams,
) =>
  [
    `/upgrade_assessments/${id}/stages/${stageNumber}/steps`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeAssessmentStageStepsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentStageSteps>>
>;
export type ListUpgradeAssessmentStageStepsQueryError = ErrorType<unknown>;

export const useListUpgradeAssessmentStageSteps = <TError = ErrorType<unknown>>(
  id: string,
  stageNumber: string,
  params?: ListUpgradeAssessmentStageStepsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentStageSteps>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(id && stageNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeAssessmentStageStepsKey(id, stageNumber, params)
        : null);
  const swrFn = () =>
    listUpgradeAssessmentStageSteps(id, stageNumber, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Create a new Step
 * @summary Create a new Step
 */
export const createUpgradeAssessmentStageStep = (
  id: string,
  stageNumber: string,
  createUpgradeAssessmentStageStepRequest: BodyType<CreateUpgradeAssessmentStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeAssessmentStageStepRequest,
    },
    options,
  );
};

export const getCreateUpgradeAssessmentStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeAssessmentStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return createUpgradeAssessmentStageStep(id, stageNumber, arg, options);
  };
};
export const getCreateUpgradeAssessmentStageStepMutationKey = (
  id: string,
  stageNumber: string,
) => `/upgrade_assessments/${id}/stages/${stageNumber}/steps` as const;

export type CreateUpgradeAssessmentStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeAssessmentStageStep>>
>;
export type CreateUpgradeAssessmentStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Create a new Step
 */
export const useCreateUpgradeAssessmentStageStep = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStep>>,
      TError,
      string,
      CreateUpgradeAssessmentStageStepRequest,
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeAssessmentStageStepMutationKey(id, stageNumber);
  const swrFn = getCreateUpgradeAssessmentStageStepMutationFetcher(
    id,
    stageNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Delete the specified Step of a Stage
 * @summary Delete an Step of a Stage
 */
export const deleteUpgradeAssessmentStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteUpgradeAssessmentStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: string, __: { arg: Arguments }): Promise<void> => {
    return deleteUpgradeAssessmentStageStep(
      id,
      stageNumber,
      stepNumber,
      options,
    );
  };
};
export const getDeleteUpgradeAssessmentStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type DeleteUpgradeAssessmentStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStep>>
>;
export type DeleteUpgradeAssessmentStageStepMutationError = ErrorType<unknown>;

/**
 * @summary Delete an Step of a Stage
 */
export const useDeleteUpgradeAssessmentStageStep = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStep>>,
      TError,
      string,
      Arguments,
      Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradeAssessmentStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getDeleteUpgradeAssessmentStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the specified Step of a Stage
 * @summary Get information about an Step of a Stage
 */
export const getUpgradeAssessmentStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeAssessmentStageStepKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  [
    `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}`,
  ] as const;

export type GetUpgradeAssessmentStageStepQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeAssessmentStageStep>>
>;
export type GetUpgradeAssessmentStageStepQueryError = ErrorType<void>;

/**
 * @summary Get information about an Step of a Stage
 */
export const useGetUpgradeAssessmentStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeAssessmentStageStep>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeAssessmentStageStepKey(id, stageNumber, stepNumber)
        : null);
  const swrFn = () =>
    getUpgradeAssessmentStageStep(id, stageNumber, stepNumber, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Update information about the specified Step of a Stage
 * @summary Update information about an Step of a Stage
 */
export const updateUpgradeAssessmentStageStep = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  updateUpgradeAssessmentStageStepRequest: BodyType<UpdateUpgradeAssessmentStageStepRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UpgradeStageStep>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUpgradeAssessmentStageStepRequest,
    },
    options,
  );
};

export const getUpdateUpgradeAssessmentStageStepMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: UpdateUpgradeAssessmentStageStepRequest },
  ): Promise<UpgradeStageStep> => {
    return updateUpgradeAssessmentStageStep(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getUpdateUpgradeAssessmentStageStepMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}` as const;

export type UpdateUpgradeAssessmentStageStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUpgradeAssessmentStageStep>>
>;
export type UpdateUpgradeAssessmentStageStepMutationError = ErrorType<void>;

/**
 * @summary Update information about an Step of a Stage
 */
export const useUpdateUpgradeAssessmentStageStep = <TError = ErrorType<void>>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof updateUpgradeAssessmentStageStep>>,
      TError,
      string,
      UpdateUpgradeAssessmentStageStepRequest,
      Awaited<ReturnType<typeof updateUpgradeAssessmentStageStep>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getUpdateUpgradeAssessmentStageStepMutationKey(id, stageNumber, stepNumber);
  const swrFn = getUpdateUpgradeAssessmentStageStepMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Trigger an action on the object.
 * @summary Trigger an action on the object
 */
export const createUpgradeAssessmentStageStepAction = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradeAssessmentStageStepActionRequest: BodyType<CreateUpgradeAssessmentStageStepActionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeAssessmentStageStepActionRequest,
    },
    options,
  );
};

export const getCreateUpgradeAssessmentStageStepActionMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeAssessmentStageStepActionRequest },
  ): Promise<void> => {
    return createUpgradeAssessmentStageStepAction(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradeAssessmentStageStepActionMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/actions` as const;

export type CreateUpgradeAssessmentStageStepActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeAssessmentStageStepAction>>
>;
export type CreateUpgradeAssessmentStageStepActionMutationError =
  ErrorType<unknown>;

/**
 * @summary Trigger an action on the object
 */
export const useCreateUpgradeAssessmentStageStepAction = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStepAction>>,
      TError,
      string,
      CreateUpgradeAssessmentStageStepActionRequest,
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStepAction>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeAssessmentStageStepActionMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getCreateUpgradeAssessmentStageStepActionMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Deletes Last Comment on Upgrade Assessment Step
 * @summary Delete Last Comment on Step
 */
export const deleteUpgradeAssessmentStageStepLastComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  deleteUpgradeAssessmentStageStepCommentRequest: BodyType<DeleteUpgradeAssessmentStageStepCommentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteUpgradeAssessmentStageStepCommentRequest,
    },
    options,
  );
};

export const getDeleteUpgradeAssessmentStageStepLastCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: DeleteUpgradeAssessmentStageStepCommentRequest },
  ): Promise<void> => {
    return deleteUpgradeAssessmentStageStepLastComment(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getDeleteUpgradeAssessmentStageStepLastCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments` as const;

export type DeleteUpgradeAssessmentStageStepLastCommentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStepLastComment>>
  >;
export type DeleteUpgradeAssessmentStageStepLastCommentMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete Last Comment on Step
 */
export const useDeleteUpgradeAssessmentStageStepLastComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStepLastComment>>,
      TError,
      string,
      DeleteUpgradeAssessmentStageStepCommentRequest,
      Awaited<ReturnType<typeof deleteUpgradeAssessmentStageStepLastComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getDeleteUpgradeAssessmentStageStepLastCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getDeleteUpgradeAssessmentStageStepLastCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all comments for the specified step.
 */
export const listUpgradeAssessmentStageStepComments = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeAssessmentStageStepCommentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentStageStepCommentsResponse>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeAssessmentStageStepCommentsKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeAssessmentStageStepCommentsParams,
) =>
  [
    `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeAssessmentStageStepCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentStageStepComments>>
>;
export type ListUpgradeAssessmentStageStepCommentsQueryError =
  ErrorType<unknown>;

export const useListUpgradeAssessmentStageStepComments = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  params?: ListUpgradeAssessmentStageStepCommentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentStageStepComments>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && stageNumber && stepNumber);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeAssessmentStageStepCommentsKey(
            id,
            stageNumber,
            stepNumber,
            params,
          )
        : null);
  const swrFn = () =>
    listUpgradeAssessmentStageStepComments(
      id,
      stageNumber,
      stepNumber,
      params,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Post a new comment on the specific step
 * @summary Post a comment on the specific step
 */
export const createUpgradeAssessmentStageStepComment = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  createUpgradeAssessmentStageStepCommentRequest: BodyType<CreateUpgradeAssessmentStageStepCommentRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUpgradeAssessmentStageStepCommentRequest,
    },
    options,
  );
};

export const getCreateUpgradeAssessmentStageStepCommentMutationFetcher = (
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: CreateUpgradeAssessmentStageStepCommentRequest },
  ): Promise<void> => {
    return createUpgradeAssessmentStageStepComment(
      id,
      stageNumber,
      stepNumber,
      arg,
      options,
    );
  };
};
export const getCreateUpgradeAssessmentStageStepCommentMutationKey = (
  id: string,
  stageNumber: string,
  stepNumber: string,
) =>
  `/upgrade_assessments/${id}/stages/${stageNumber}/steps/${stepNumber}/comments` as const;

export type CreateUpgradeAssessmentStageStepCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpgradeAssessmentStageStepComment>>
>;
export type CreateUpgradeAssessmentStageStepCommentMutationError =
  ErrorType<unknown>;

/**
 * @summary Post a comment on the specific step
 */
export const useCreateUpgradeAssessmentStageStepComment = <
  TError = ErrorType<unknown>,
>(
  id: string,
  stageNumber: string,
  stepNumber: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStepComment>>,
      TError,
      string,
      CreateUpgradeAssessmentStageStepCommentRequest,
      Awaited<ReturnType<typeof createUpgradeAssessmentStageStepComment>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ??
    getCreateUpgradeAssessmentStageStepCommentMutationKey(
      id,
      stageNumber,
      stepNumber,
    );
  const swrFn = getCreateUpgradeAssessmentStageStepCommentMutationFetcher(
    id,
    stageNumber,
    stepNumber,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about the resources that remained unclassified during an Upgrade Assessment generation.
 * @summary List unclassified resources from an Upgrade Assessment
 */
export const listUpgradeAssessmentUnclassifiedResources = (
  id: string,
  params?: ListUpgradeAssessmentUnclassifiedResourcesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentUnclassifiedResourcesResponse>(
    {
      url: `/upgrade_assessments/${id}/unclassified_resources`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeAssessmentUnclassifiedResourcesKey = (
  id: string,
  params?: ListUpgradeAssessmentUnclassifiedResourcesParams,
) =>
  [
    `/upgrade_assessments/${id}/unclassified_resources`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeAssessmentUnclassifiedResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentUnclassifiedResources>>
>;
export type ListUpgradeAssessmentUnclassifiedResourcesQueryError =
  ErrorType<void>;

/**
 * @summary List unclassified resources from an Upgrade Assessment
 */
export const useListUpgradeAssessmentUnclassifiedResources = <
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListUpgradeAssessmentUnclassifiedResourcesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentUnclassifiedResources>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeAssessmentUnclassifiedResourcesKey(id, params)
        : null);
  const swrFn = () =>
    listUpgradeAssessmentUnclassifiedResources(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns information about suggested changes to Package Installs based on an Upgrade Assessment.
 * @summary List changes to Package Installs from an Upgrade Assessment
 */
export const listUpgradeAssessmentPackageInstallChanges = (
  id: string,
  params?: ListUpgradeAssessmentPackageInstallChangesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentPackageInstallChangesResponse>(
    {
      url: `/upgrade_assessments/${id}/package_install_changes`,
      method: 'GET',
      params,
    },
    options,
  );
};

export const getListUpgradeAssessmentPackageInstallChangesKey = (
  id: string,
  params?: ListUpgradeAssessmentPackageInstallChangesParams,
) =>
  [
    `/upgrade_assessments/${id}/package_install_changes`,
    ...(params ? [params] : []),
  ] as const;

export type ListUpgradeAssessmentPackageInstallChangesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUpgradeAssessmentPackageInstallChanges>>
>;
export type ListUpgradeAssessmentPackageInstallChangesQueryError =
  ErrorType<void>;

/**
 * @summary List changes to Package Installs from an Upgrade Assessment
 */
export const useListUpgradeAssessmentPackageInstallChanges = <
  TError = ErrorType<void>,
>(
  id: string,
  params?: ListUpgradeAssessmentPackageInstallChangesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listUpgradeAssessmentPackageInstallChanges>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!id;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getListUpgradeAssessmentPackageInstallChangesKey(id, params)
        : null);
  const swrFn = () =>
    listUpgradeAssessmentPackageInstallChanges(id, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get a specific Package Install Change from an Upgrade Assessment
 */
export const getUpgradeAssessmentPackageInstallChange = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PackageInstallChange>(
    {
      url: `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeAssessmentPackageInstallChangeKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}`,
  ] as const;

export type GetUpgradeAssessmentPackageInstallChangeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradeAssessmentPackageInstallChange>>
>;
export type GetUpgradeAssessmentPackageInstallChangeQueryError =
  ErrorType<void>;

/**
 * @summary Get a specific Package Install Change from an Upgrade Assessment
 */
export const useGetUpgradeAssessmentPackageInstallChange = <
  TError = ErrorType<void>,
>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getUpgradeAssessmentPackageInstallChange>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeAssessmentPackageInstallChangeKey(
            id,
            packageInstallChangeId,
          )
        : null);
  const swrFn = () =>
    getUpgradeAssessmentPackageInstallChange(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get the Notable Changes for a Package Install Change from an Upgrade Assessment
 */
export const getUpgradeAssessmentPackageInstallChangeNotableChanges = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<NotableChanges>(
    {
      url: `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}/notable_changes`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeAssessmentPackageInstallChangeNotableChangesKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}/notable_changes`,
  ] as const;

export type GetUpgradeAssessmentPackageInstallChangeNotableChangesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getUpgradeAssessmentPackageInstallChangeNotableChanges>
    >
  >;
export type GetUpgradeAssessmentPackageInstallChangeNotableChangesQueryError =
  ErrorType<void>;

/**
 * @summary Get the Notable Changes for a Package Install Change from an Upgrade Assessment
 */
export const useGetUpgradeAssessmentPackageInstallChangeNotableChanges = <
  TError = ErrorType<void>,
>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<
        ReturnType<
          typeof getUpgradeAssessmentPackageInstallChangeNotableChanges
        >
      >,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeAssessmentPackageInstallChangeNotableChangesKey(
            id,
            packageInstallChangeId,
          )
        : null);
  const swrFn = () =>
    getUpgradeAssessmentPackageInstallChangeNotableChanges(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get the Reasons for a Package Install Change from an Upgrade Assessment
 */
export const getUpgradeAssessmentPackageInstallChangeReasons = (
  id: string,
  packageInstallChangeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListUpgradeAssessmentPackageInstallChangeReasonsResponse>(
    {
      url: `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}/reasons`,
      method: 'GET',
    },
    options,
  );
};

export const getGetUpgradeAssessmentPackageInstallChangeReasonsKey = (
  id: string,
  packageInstallChangeId: string,
) =>
  [
    `/upgrade_assessments/${id}/package_install_changes/${packageInstallChangeId}/reasons`,
  ] as const;

export type GetUpgradeAssessmentPackageInstallChangeReasonsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUpgradeAssessmentPackageInstallChangeReasons>>
  >;
export type GetUpgradeAssessmentPackageInstallChangeReasonsQueryError =
  ErrorType<void>;

/**
 * @summary Get the Reasons for a Package Install Change from an Upgrade Assessment
 */
export const useGetUpgradeAssessmentPackageInstallChangeReasons = <
  TError = ErrorType<void>,
>(
  id: string,
  packageInstallChangeId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<
        ReturnType<typeof getUpgradeAssessmentPackageInstallChangeReasons>
      >,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false && !!(id && packageInstallChangeId);
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled
        ? getGetUpgradeAssessmentPackageInstallChangeReasonsKey(
            id,
            packageInstallChangeId,
          )
        : null);
  const swrFn = () =>
    getUpgradeAssessmentPackageInstallChangeReasons(
      id,
      packageInstallChangeId,
      requestOptions,
    );

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all the SHARCFlow runs for a SHARCFlow Id, including the run details of all its associated Checks.
 * @summary Retrieve all the SHARCFlow runs for a specific SHARCFlow Id
 */
export const listSHARCFlowruns = (
  sharcflowId: string,
  params?: ListSHARCFlowrunsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListSHARCFlowRunsResponse>(
    { url: `/sharcflows/${sharcflowId}/runs`, method: 'GET', params },
    options,
  );
};

export const getListSHARCFlowrunsKey = (
  sharcflowId: string,
  params?: ListSHARCFlowrunsParams,
) => [`/sharcflows/${sharcflowId}/runs`, ...(params ? [params] : [])] as const;

export type ListSHARCFlowrunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSHARCFlowruns>>
>;
export type ListSHARCFlowrunsQueryError = ErrorType<void>;

/**
 * @summary Retrieve all the SHARCFlow runs for a specific SHARCFlow Id
 */
export const useListSHARCFlowruns = <TError = ErrorType<void>>(
  sharcflowId: string,
  params?: ListSHARCFlowrunsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listSHARCFlowruns>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!sharcflowId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListSHARCFlowrunsKey(sharcflowId, params) : null));
  const swrFn = () => listSHARCFlowruns(sharcflowId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve information about a SHARCFlow Run
 * @summary Retrieve information about a SHARCFlow Run
 */
export const getSHARCFlowRun = (
  sharcflowId: string,
  runId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SHARCFlowRun>(
    { url: `/sharcflows/${sharcflowId}/runs/${runId}`, method: 'GET' },
    options,
  );
};

export const getGetSHARCFlowRunKey = (sharcflowId: string, runId: string) =>
  [`/sharcflows/${sharcflowId}/runs/${runId}`] as const;

export type GetSHARCFlowRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSHARCFlowRun>>
>;
export type GetSHARCFlowRunQueryError = ErrorType<void>;

/**
 * @summary Retrieve information about a SHARCFlow Run
 */
export const useGetSHARCFlowRun = <TError = ErrorType<void>>(
  sharcflowId: string,
  runId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSHARCFlowRun>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!(sharcflowId && runId);
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSHARCFlowRunKey(sharcflowId, runId) : null));
  const swrFn = () => getSHARCFlowRun(sharcflowId, runId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns every container image entry across all projects, keyed by project slug.
 * @summary List all SHARC container images
 */
export const listSHARCImages = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListSHARCImagesResponse>(
    { url: `/sharc/images`, method: 'GET' },
    options,
  );
};

export const getListSHARCImagesKey = () => [`/sharc/images`] as const;

export type ListSHARCImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSHARCImages>>
>;
export type ListSHARCImagesQueryError = ErrorType<unknown>;

/**
 * @summary List all SHARC container images
 */
export const useListSHARCImages = <TError = ErrorType<unknown>>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof listSHARCImages>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListSHARCImagesKey() : null));
  const swrFn = () => listSHARCImages(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Returns the container image entries known for the specified project.
 * @summary Get the SHARC container images for a project
 */
export const getSHARCProjectImages = (
  project: string,
  params?: GetSHARCProjectImagesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GetSHARCProjectImagesResponse>(
    { url: `/sharc/image/${project}`, method: 'GET', params },
    options,
  );
};

export const getGetSHARCProjectImagesKey = (
  project: string,
  params?: GetSHARCProjectImagesParams,
) => [`/sharc/image/${project}`, ...(params ? [params] : [])] as const;

export type GetSHARCProjectImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSHARCProjectImages>>
>;
export type GetSHARCProjectImagesQueryError = ErrorType<void>;

/**
 * @summary Get the SHARC container images for a project
 */
export const useGetSHARCProjectImages = <TError = ErrorType<void>>(
  project: string,
  params?: GetSHARCProjectImagesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSHARCProjectImages>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!project;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSHARCProjectImagesKey(project, params) : null));
  const swrFn = () => getSHARCProjectImages(project, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve all risks
 * @summary Retrieve all risks
 */
export const listRisks = (
  params?: ListRisksParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListRisksResponse>(
    { url: `/risks`, method: 'GET', params },
    options,
  );
};

export const getListRisksKey = (params?: ListRisksParams) =>
  [`/risks`, ...(params ? [params] : [])] as const;

export type ListRisksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRisks>>
>;
export type ListRisksQueryError = ErrorType<unknown>;

/**
 * @summary Retrieve all risks
 */
export const useListRisks = <TError = ErrorType<unknown>>(
  params?: ListRisksParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof listRisks>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListRisksKey(params) : null));
  const swrFn = () => listRisks(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve information about a risk
 * @summary Retrieve information about a risk
 */
export const getRisk = (
  riskId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Risk>(
    { url: `/risks/${riskId}`, method: 'GET' },
    options,
  );
};

export const getGetRiskKey = (riskId: string) => [`/risks/${riskId}`] as const;

export type GetRiskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRisk>>
>;
export type GetRiskQueryError = ErrorType<void>;

/**
 * @summary Retrieve information about a risk
 */
export const useGetRisk = <TError = ErrorType<void>>(
  riskId: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getRisk>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!riskId;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetRiskKey(riskId) : null));
  const swrFn = () => getRisk(riskId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List the resources of a specific risk
 */
export const listRiskAffectedResources = (
  riskId: string,
  params?: ListRiskAffectedResourcesParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListRiskResourcesResponse>(
    { url: `/risks/${riskId}/resources`, method: 'GET', params },
    options,
  );
};

export const getListRiskAffectedResourcesKey = (
  riskId: string,
  params?: ListRiskAffectedResourcesParams,
) => [`/risks/${riskId}/resources`, ...(params ? [params] : [])] as const;

export type ListRiskAffectedResourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRiskAffectedResources>>
>;
export type ListRiskAffectedResourcesQueryError = ErrorType<unknown>;

export const useListRiskAffectedResources = <TError = ErrorType<unknown>>(
  riskId: string,
  params?: ListRiskAffectedResourcesParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listRiskAffectedResources>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!riskId;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getListRiskAffectedResourcesKey(riskId, params) : null);
  const swrFn = () => listRiskAffectedResources(riskId, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve agent by slug
 * @summary Get an agent
 */
export const getAgent = (
  agentSlug: AgentSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Agent>(
    { url: `/agents/${agentSlug}`, method: 'GET' },
    options,
  );
};

export const getGetAgentKey = (agentSlug: AgentSlug) =>
  [`/agents/${agentSlug}`] as const;

export type GetAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgent>>
>;
export type GetAgentQueryError = ErrorType<void>;

/**
 * @summary Get an agent
 */
export const useGetAgent = <TError = ErrorType<void>>(
  agentSlug: AgentSlug,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAgent>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!agentSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAgentKey(agentSlug) : null));
  const swrFn = () => getAgent(agentSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * List sub-agents for a parent agent
 * @summary List sub-agents for a parent agent
 */
export const listSubagents = (
  agentSlug: AgentSlug,
  params?: ListSubagentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListSubagentsResponse>(
    { url: `/agents/${agentSlug}/subagents`, method: 'GET', params },
    options,
  );
};

export const getListSubagentsKey = (
  agentSlug: AgentSlug,
  params?: ListSubagentsParams,
) => [`/agents/${agentSlug}/subagents`, ...(params ? [params] : [])] as const;

export type ListSubagentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubagents>>
>;
export type ListSubagentsQueryError = ErrorType<void>;

/**
 * @summary List sub-agents for a parent agent
 */
export const useListSubagents = <TError = ErrorType<void>>(
  agentSlug: AgentSlug,
  params?: ListSubagentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listSubagents>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!agentSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListSubagentsKey(agentSlug, params) : null));
  const swrFn = () => listSubagents(agentSlug, params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get recipe metadata for the agent
 * @summary Get recipe metadata (digest + links to raw content)
 */
export const getAgentRecipeMetadata = (
  agentSlug: AgentSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AgentRecipeMetadata>(
    { url: `/agents/${agentSlug}/recipe`, method: 'GET' },
    options,
  );
};

export const getGetAgentRecipeMetadataKey = (agentSlug: AgentSlug) =>
  [`/agents/${agentSlug}/recipe`] as const;

export type GetAgentRecipeMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentRecipeMetadata>>
>;
export type GetAgentRecipeMetadataQueryError = ErrorType<void>;

/**
 * @summary Get recipe metadata (digest + links to raw content)
 */
export const useGetAgentRecipeMetadata = <TError = ErrorType<void>>(
  agentSlug: AgentSlug,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAgentRecipeMetadata>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!agentSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAgentRecipeMetadataKey(agentSlug) : null));
  const swrFn = () => getAgentRecipeMetadata(agentSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get raw recipe in Markdown for the agent
 * @summary Get raw recipe in markdown format
 */
export const getAgentRecipeRaw = (
  agentSlug: AgentSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<string>(
    { url: `/agents/${agentSlug}/recipe/raw`, method: 'GET' },
    options,
  );
};

export const getGetAgentRecipeRawKey = (agentSlug: AgentSlug) =>
  [`/agents/${agentSlug}/recipe/raw`] as const;

export type GetAgentRecipeRawQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentRecipeRaw>>
>;
export type GetAgentRecipeRawQueryError = ErrorType<void>;

/**
 * @summary Get raw recipe in markdown format
 */
export const useGetAgentRecipeRaw = <TError = ErrorType<void>>(
  agentSlug: AgentSlug,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAgentRecipeRaw>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!agentSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAgentRecipeRawKey(agentSlug) : null));
  const swrFn = () => getAgentRecipeRaw(agentSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get metadata for the latest published skill release
 * @summary Get the latest skill metadata
 */
export const getSkill = (
  skillSlug: SkillSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Skill>(
    { url: `/skills/${skillSlug}`, method: 'GET' },
    options,
  );
};

export const getGetSkillKey = (skillSlug: SkillSlug) =>
  [`/skills/${skillSlug}`] as const;

export type GetSkillQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSkill>>
>;
export type GetSkillQueryError = ErrorType<void>;

/**
 * @summary Get the latest skill metadata
 */
export const useGetSkill = <TError = ErrorType<void>>(
  skillSlug: SkillSlug,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getSkill>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!skillSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSkillKey(skillSlug) : null));
  const swrFn = () => getSkill(skillSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get recipe metadata for the skill
 * @summary Get skill recipe metadata
 */
export const getSkillRecipeMetadata = (
  skillSlug: SkillSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SkillRecipeMetadata>(
    { url: `/skills/${skillSlug}/recipe`, method: 'GET' },
    options,
  );
};

export const getGetSkillRecipeMetadataKey = (skillSlug: SkillSlug) =>
  [`/skills/${skillSlug}/recipe`] as const;

export type GetSkillRecipeMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSkillRecipeMetadata>>
>;
export type GetSkillRecipeMetadataQueryError = ErrorType<void>;

/**
 * @summary Get skill recipe metadata
 */
export const useGetSkillRecipeMetadata = <TError = ErrorType<void>>(
  skillSlug: SkillSlug,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSkillRecipeMetadata>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!skillSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSkillRecipeMetadataKey(skillSlug) : null));
  const swrFn = () => getSkillRecipeMetadata(skillSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Get raw recipe in Markdown for the skill
 * @summary Get raw skill recipe in markdown format
 */
export const getSkillRecipeRaw = (
  skillSlug: SkillSlug,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<string>(
    { url: `/skills/${skillSlug}/recipe/raw`, method: 'GET' },
    options,
  );
};

export const getGetSkillRecipeRawKey = (skillSlug: SkillSlug) =>
  [`/skills/${skillSlug}/recipe/raw`] as const;

export type GetSkillRecipeRawQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSkillRecipeRaw>>
>;
export type GetSkillRecipeRawQueryError = ErrorType<void>;

/**
 * @summary Get raw skill recipe in markdown format
 */
export const useGetSkillRecipeRaw = <TError = ErrorType<void>>(
  skillSlug: SkillSlug,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSkillRecipeRaw>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!skillSlug;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSkillRecipeRawKey(skillSlug) : null));
  const swrFn = () => getSkillRecipeRaw(skillSlug, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * GET requests to the Chat API in another account.
 * @summary GET to Chat
 */
export const chatGet = (options?: SecondParameter<typeof customInstance>) => {
  return customInstance<ChatGet200>(
    { url: `/chat/url+}`, method: 'GET' },
    options,
  );
};

export const getChatGetKey = () => [`/chat/url+}`] as const;

export type ChatGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatGet>>
>;
export type ChatGetQueryError = ErrorType<void>;

/**
 * @summary GET to Chat
 */
export const useChatGet = <TError = ErrorType<void>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof chatGet>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getChatGetKey() : null));
  const swrFn = () => chatGet(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * POST requests to the Chat API in another account.
 * @summary POST to Chat
 */
export const chatPost = (
  chatPostBody?: BodyType<ChatPostBody>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChatPost200 | ChatPost201>(
    {
      url: `/chat/url+}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: chatPostBody,
    },
    options,
  );
};

export const getChatPostMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: string,
    { arg }: { arg: ChatPostBody },
  ): Promise<ChatPost200 | ChatPost201> => {
    return chatPost(arg, options);
  };
};
export const getChatPostMutationKey = () => `/chat/url+}` as const;

export type ChatPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatPost>>
>;
export type ChatPostMutationError = ErrorType<void>;

/**
 * @summary POST to Chat
 */
export const useChatPost = <TError = ErrorType<void>>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof chatPost>>,
    TError,
    string,
    ChatPostBody,
    Awaited<ReturnType<typeof chatPost>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getChatPostMutationKey();
  const swrFn = getChatPostMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get all feature flag treatments for a user
 */
export const listTreatments = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ListAllTreatmentsResponse>(
    { url: `/treatments`, method: 'GET' },
    options,
  );
};

export const getListTreatmentsKey = () => [`/treatments`] as const;

export type ListTreatmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTreatments>>
>;
export type ListTreatmentsQueryError = ErrorType<void>;

/**
 * @summary Get all feature flag treatments for a user
 */
export const useListTreatments = <TError = ErrorType<void>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof listTreatments>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getListTreatmentsKey() : null));
  const swrFn = () => listTreatments(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};
